export const translations = {
    en: {
        cvLinkText: "See my CV",
        visitText: "Visit",
        heroTitle: "Mickael Saidi, Full-stack Developer (Front-end and Back-end)",
        heroSubtitle: "I develop all types of web applications",
        presentationTitle: "Hello, my name is Mickael, welcome to my portfolio!",
        presentationText: "Graduated with a Master's degree in software engineering, I am currently looking for a company to apply my development skills. Passionate about computers for over a decade, web development has always fascinated me.",
        skillsTitle: "Skills",
        toolsTitle: "The tools I use for most of my projects",
        projectsTitle: "The companies I have worked for",
        documentationTitle: "Documentations (PDF)",
        seemoreText: "Want to know more?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Languages / Technologies mastered",
        projetsText: "The companies I have worked for",
        docDescription1: "This documentation can serve as a basis for designing a secure and encrypted system.",
        docDescription2: "A large part of the most common cyber attacks on websites.",
        docDescription3: "Biometric means are increasingly used for the security of IT systems and websites.",
        company1: "Advanced development and optimization of PHP (Symfony) applications, integrating scalability technologies such as AWS and DynamoDB. Enhancement and refactoring of existing modules in Symfony and Angular to optimize performance and code maintainability. Design and integration of an advanced customization system, enabling dynamic site color modification. Architecture modernization to strengthen stability and scalability of application platforms.",
        company2: "Design and development of a web platform dedicated to dynamic form management, inspired by TypeForm, leveraging Symfony 4, PHP and JavaScript. Implementation of advanced functional tests with PHPUnit to ensure stability, reliability and overall quality of the platform and its application architecture.",
        company3: "Development of custom web solutions using Symfony/Laravel, including REST API integration and front-end implementation. Deployment automation with Docker and GitLab CI/CD, reducing human errors and accelerating production releases. Database optimization (MySQL, PostgreSQL), achieving a 50% reduction in SQL query execution time. Technical consulting and support on scalability and legacy architecture redesign for various clients.",
        company4: "Development of custom solutions in PHP, SQL, HTML, CSS, JavaScript and jQuery. Active contribution to continuous improvement and evolution of a proprietary framework, ensuring its stability, scalability and compatibility with emerging market technologies.",
        company5: "Development and integration of interactive and dynamic user interfaces in AngularJS, leveraging HTML, CSS and Bootstrap to ensure a smooth and responsive user experience. Implementation of front-end best practices to guarantee performance, maintainability and cross-platform compatibility.",
        company6: "Creation in 2012 of a service provider of VPS (Virtual private server) by dispatching a dedicated server with DDoS protection of 10gbps.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Languages / Technologies mastered",
        machineLearningTitle: "Machine Learning",
        frameworksTitle: "Frameworks / Libraries",
        // Value Proposition
        valuePropositionTitle: "Why Work With Me?",
        valuePropositionSubtitle: "Delivering excellence through proven expertise and cutting-edge technology",
        valuePropositionFastTitle: "Fast Delivery",
        valuePropositionFastDesc: "Solid architecture from day one. Clean, scalable, and maintainable code that stands the test of time.",
        valuePropositionSecurityTitle: "Enterprise Security",
        valuePropositionSecurityDesc: "Cybersecurity expert. Your data and your users' information are protected with industry-leading practices.",
        valuePropositionTechTitle: "Modern Stack",
        valuePropositionTechDesc: "React, TypeScript, Symfony, AWS. Battle-tested technologies for applications that scale.",
        // Case Studies
        caseStudiesTitle: "Featured Projects",
        caseStudiesSubtitle: "Real results from real-world challenges",
        caseStudyBadge: "Case Study",
        caseStudyMetricUsers: "Users",
        caseStudyMetricPerformance: "Faster",
        caseStudyMetricConversion: "Conversion",
        // Final CTA
        finalCtaTitle: "Ready to Launch Your Project?",
        finalCtaSubtitle: "Guaranteed response within 24 hours",
        finalCtaPrimary: "Let's Discuss Your Project",
        finalCtaSecondary: "Download My CV",
        // Updated Hero
        heroTitleNew: "I Transform Your Ideas Into High-Performance Web Applications",
        heroSubtitleNew: "Full-Stack Developer • 13+ Years • 50+ Projects • 120k+ Users Impacted",
        heroCtaMain: "See My Work",
        // Skills Compact
        skillsCompactTitle: "Technology Stack",
        skillsCompactExpand: "View All Skills",
        skillsCompactCollapse: "Show Less",
        // Additional translations
        toolsSubtitle: "Professional tools and technologies I use to bring ideas to life",
        projectsSubtitle: "Professional journey across innovative companies and challenging projects",
        documentationSubtitle: "Technical documentation and research papers on cybersecurity and system architecture",
        contactSubtitle: "Ready to bring your next project to life? Let's collaborate and create something amazing together.",
        contactGetInTouch: "Get In Touch",
        contactFollowMe: "Follow Me",
        contactSendMessage: "Send a Message",
        contactAvailable: "Available for Projects",
        contactAvailableDesc: "Currently accepting new freelance projects and full-time opportunities. Response time: 24-48 hours.",
        contactNameLabel: "Name",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Subject",
        contactMessageLabel: "Message",
        contactNamePlaceholder: "Your full name",
        contactEmailPlaceholder: "your.email@example.com",
        contactSubjectPlaceholder: "Project inquiry, collaboration, etc.",
        contactMessagePlaceholder: "Tell me about your project, requirements, timeline, and budget...",
        contactSendButton: "Send Message",
        contactSendingButton: "Sending...",
        contactErrorTitle: "Message delivery failed",
        contactErrorMessage: "An error occurred while sending your message. Please try again later.",
        contactTimeoutMessage: "The request timed out. Please check your connection and try again.",
        footerMadeWith: "Made with",
        footerPoweredBy: "powered by",
        footerRights: "All rights reserved.",
        footerBuiltWith: "Built with React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Years Experience",
        statsProjectsDone: "Projects Done",
        statsUsersReached: "Users Reached",
        statsProjectsCompleted: "Projects Completed",
        statsUsersImpacted: "Users Impacted",
        statsTechMastered: "Technologies Mastered",
        developmentCategory: "Development",
        databasesCategory: "Databases",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Design",
        testingCategory: "Testing & QA",
        buildToolsCategory: "Build Tools",
        coreStackTitle: "Core Technology Stack",
        docLibraryTitle: "Technical Documentation Library",
        docLibraryDesc: "These comprehensive documents represent years of research and practical experience in cybersecurity, system architecture, and modern authentication systems. Each paper provides detailed insights, implementation guidelines, and best practices for enterprise-level solutions.",
        docTotalPages: "Total Pages",
        docResearchPapers: "Research Papers",
        docEnterpriseReady: "Enterprise Ready",
        downloadPdf: "Download PDF",
        preview: "Preview",
        pages: "pages",
        missingInfo: "Missing Information",
        fillRequired: "Please fill in all required fields.",
        messageSent: "Message Sent!",
        messageThankYou: "Thank you for your message. I'll get back to you soon.",
        menu: {
            skills: "Skills",
            tools: "Tools",
            projects: "Projects",
            blog: "Blog",
            games: "Games",
            chat: "Chat",
            docs: "Docs",
            contact: "Contact"
        },
        themeToggle: {
            light: "Switch to light mode",
            dark: "Switch to dark mode"
        },
        blog: {
            title: "Blog",
            subtitle: "Discover innovative insights and practical guides",
            searchPlaceholder: "Search articles...",
            searchButton: "Search",
            filterAll: "All",
            loading: "Loading articles...",
            noResults: "No articles found",
            clearFilters: "Clear Filters",
            tags: {
                "developpement-web": "Web Development",
                "intelligence-artificielle": "Artificial Intelligence",
                "machine-learning": "Machine Learning",
                ia: "AI",
                developpement: "Development",
                "revue-de-code": "Code Review",
                productivite: "Productivity",
                outils: "Tools",
                startups: "Startups",
                technologie: "Technology",
                innovation: "Innovation",
                durabilite: "Sustainability",
                fintech: "Fintech",
                react: "React",
                pwa: "Progressive Web Apps",
                microservices: "Microservices",
                "technologie-moderne": "Modern Technology",
                css: "CSS",
                "web-design": "Web Design",
                "responsive-design": "Responsive Design",
                "grid-layout": "Grid Layout",
                reglementations: "Regulations",
                tech: "Tech",
                "vie-privee": "Privacy",
                donnees: "Data"
            }
        },
        blogPost: {
            backToBlog: "Back to Blog",
            readMore: "Read More Articles",
            availableLanguagesTitle: "Available in other languages",
            originalBadge: "Original",
            tableOfContentsTitle: "Table of contents",
            keywords: "Keywords",
            date: "Date",
            readingTime: "min read",
            views: "views",
            share: {
                title: "Share this article",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "Email",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "Share via your device",
                copy: "Copy Link",
                errorNoUrlTitle: "Sharing unavailable",
                errorNoUrlDescription: "We could not retrieve the article URL.",
                errorWindowTitle: "Share failed",
                errorWindowDescription: "We could not open the share window.",
                copySuccessTitle: "Link copied",
                copySuccessDescription: "The article link was copied to your clipboard.",
                copyErrorTitle: "Copy failed",
                copyErrorDescription: "Please try again or copy the address manually."
            },
            newsletter: {
                badge: "Stay ahead",
                title: "Inspire your 2025-2026 projects",
                description: "Get a weekly digest of French tech trends, AI tools, and actionable tactics to accelerate your products.",
                namePlaceholder: "Your first name (optional)",
                emailPlaceholder: "your.email@example.com",
                buttonIdle: "Subscribe",
                buttonLoading: "Subscribing...",
                infoDefault: "No spam—just concise insights and ready-to-use tools for your 2025-2026 initiatives. Unsubscribe any time.",
                infoSuccess: "Thanks! Please check your inbox to confirm your subscription.",
                toastMissingEmailTitle: "Email required",
                toastMissingEmailDescription: "Please provide a valid email address to receive our updates.",
                toastSuccessTitle: "Welcome to the newsletter!",
                toastSuccessDescription: "You'll soon receive our latest articles and insights.",
                toastErrorTitle: "Subscription failed",
                toastErrorDescription: "Please try again in a few moments."
            }
        },
        articleReader: {
            title: "Listen to the article",
            loading: "Loading...",
            voiceLabel: "Voice",
            femaleVoice: "Female",
            maleVoice: "Male",
            volumeLabel: "Volume",
            speedLabel: "Speed",            poweredBy: "Nukoe Vocal Transcription"
        }
    },
    de: {
        cvLinkText: "Lebenslauf anzeigen",
        visitText: "Besuchen",
        heroTitle: "Mickael Saidi, Full-Stack-Entwickler (Front-End und Back-End)",
        heroSubtitle: "Ich entwickle alle Arten von Webanwendungen",
        presentationTitle: "Hallo, ich bin Mickael – willkommen in meinem Portfolio!",
        presentationText: "Mit einem Master in Software Engineering suche ich aktuell nach einem Unternehmen, in dem ich meine Entwicklungskompetenzen einsetzen kann. Seit über zehn Jahren begeistert mich die Informatik, besonders die Webentwicklung.",
        skillsTitle: "Kompetenzen",
        toolsTitle: "Die Tools, die ich in den meisten Projekten einsetze",
        projectsTitle: "Unternehmen, für die ich gearbeitet habe",
        documentationTitle: "Dokumentationen (PDF)",
        seemoreText: "Mehr erfahren?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Beherrschte Sprachen / Technologien",
        projetsText: "Unternehmen, für die ich gearbeitet habe",
        docDescription1: "Diese Dokumentation kann als Grundlage für den Entwurf eines sicheren, verschlüsselten Systems dienen.",
        docDescription2: "Ein Überblick über die häufigsten Cyberangriffe auf Websites.",
        docDescription3: "Biometrische Verfahren werden immer häufiger eingesetzt, um IT-Systeme und Websites zu schützen.",
        company1: "Fortgeschrittene Entwicklung und Optimierung von PHP-Anwendungen (Symfony) mit Skalierungstechnologien wie AWS und DynamoDB. Verbesserung und Refactoring bestehender Module in Symfony und Angular zur Performance- und Code-Wartbarkeitsoptimierung. Design und Integration eines erweiterten Anpassungssystems für dynamische Website-Farbänderungen. Architekturmodernisierung zur Stärkung der Stabilität und Skalierbarkeit von Anwendungsplattformen.",
        company2: "Design und Entwicklung einer Webplattform für dynamisches Formularmanagement, inspiriert von TypeForm, unter Nutzung von Symfony 4, PHP und JavaScript. Implementierung fortgeschrittener Funktionstests mit PHPUnit zur Gewährleistung von Stabilität, Zuverlässigkeit und Gesamtqualität der Plattform und ihrer Anwendungsarchitektur.",
        company3: "Entwicklung maßgeschneiderter Weblösungen mit Symfony/Laravel, einschließlich REST-API-Integration und Front-End-Implementierung. Automatisierung der Bereitstellung mit Docker und GitLab CI/CD zur Reduzierung menschlicher Fehler und Beschleunigung von Produktionsveröffentlichungen. Datenbankoptimierung (MySQL, PostgreSQL) mit 50% Reduzierung der SQL-Abfrageausführungszeit. Technische Beratung und Unterstützung bei Skalierbarkeit und Neugestaltung von Legacy-Architekturen für verschiedene Kunden.",
        company4: "Entwicklung maßgeschneiderter Lösungen in PHP, SQL, HTML, CSS, JavaScript und jQuery. Aktive Mitwirkung an der kontinuierlichen Verbesserung und Weiterentwicklung eines proprietären Frameworks zur Gewährleistung seiner Stabilität, Skalierbarkeit und Kompatibilität mit aufkommenden Markttechnologien.",
        company5: "Entwicklung und Integration interaktiver und dynamischer Benutzeroberflächen in AngularJS unter Verwendung von HTML, CSS und Bootstrap zur Gewährleistung einer flüssigen und responsiven Benutzererfahrung. Implementierung von Front-End-Best-Practices zur Garantie von Performance, Wartbarkeit und plattformübergreifender Kompatibilität.",
        company6: "2012 Aufbau eines VPS-Hosting-Anbieters durch Aufteilung eines Dedicated Servers mit 10-Gbit/s-DDoS-Schutz.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Beherrschte Sprachen / Technologien",
        machineLearningTitle: "Machine Learning",
        frameworksTitle: "Frameworks / Bibliotheken",
        toolsSubtitle: "Professionelle Tools und Technologien, mit denen ich Ideen realisiere",
        projectsSubtitle: "Beruflicher Werdegang durch innovative Unternehmen und spannende Projekte",
        documentationSubtitle: "Technische Dokumentation und Forschungsarbeiten zu Cybersecurity und Systemarchitektur",
        contactSubtitle: "Bereit für Ihr nächstes Projekt? Lassen Sie uns gemeinsam etwas Großartiges schaffen.",
        contactGetInTouch: "Kontakt aufnehmen",
        contactFollowMe: "Folgen",
        contactSendMessage: "Nachricht senden",
        contactAvailable: "Verfügbar für Projekte",
        contactAvailableDesc: "Derzeit offen für neue Freelance-Projekte und Festanstellungen. Antwortzeit: 24-48 Stunden.",
        contactNameLabel: "Name",
        contactEmailLabel: "E-Mail",
        contactSubjectLabel: "Betreff",
        contactMessageLabel: "Nachricht",
        contactNamePlaceholder: "Ihr vollständiger Name",
        contactEmailPlaceholder: "ihre.email@beispiel.de",
        contactSubjectPlaceholder: "Projektanfrage, Zusammenarbeit usw.",
        contactMessagePlaceholder: "Erzählen Sie mir von Ihrem Projekt, Anforderungen, Zeitplan und Budget...",
        contactSendButton: "Nachricht senden",
        contactSendingButton: "Senden...",
        contactErrorTitle: "Nachricht nicht gesendet",
        contactErrorMessage: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
        contactTimeoutMessage: "Zeitüberschreitung. Bitte Verbindung prüfen und erneut versuchen.",
        footerMadeWith: "Erstellt mit",
        footerPoweredBy: "powered by",
        footerRights: "Alle Rechte vorbehalten.",
        footerBuiltWith: "Erstellt mit React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Jahre Erfahrung",
        statsProjectsDone: "Projekte",
        statsUsersReached: "Erreichte Nutzer",
        statsProjectsCompleted: "Abgeschlossene Projekte",
        statsUsersImpacted: "Betroffene Nutzer",
        statsTechMastered: "Beherrschte Technologien",
        developmentCategory: "Entwicklung",
        databasesCategory: "Datenbanken",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Design",
        testingCategory: "Tests & QA",
        buildToolsCategory: "Build Tools",
        coreStackTitle: "Kerntechnologie-Stack",
        docLibraryTitle: "Technische Dokumentationsbibliothek",
        docLibraryDesc: "Diese umfangreichen Dokumente spiegeln jahrelange Forschung und Praxis in den Bereichen Cybersecurity, Systemarchitektur und moderne Authentifizierungsverfahren wider. Jedes Papier enthält detaillierte Erkenntnisse, Implementierungsleitfäden und Best Practices für Enterprise-Lösungen.",
        docTotalPages: "Seiten insgesamt",
        docResearchPapers: "Fachartikel",
        docEnterpriseReady: "Enterprise-tauglich",
        downloadPdf: "PDF herunterladen",
        preview: "Vorschau",
        pages: "Seiten",
        missingInfo: "Fehlende Information",
        fillRequired: "Bitte alle Pflichtfelder ausfüllen.",
        messageSent: "Nachricht gesendet!",
        messageThankYou: "Vielen Dank für Ihre Nachricht. Ich melde mich bald.",
        messageReceived: "Ich melde mich innerhalb von 24-48 Stunden.",
        menu: {
            skills: "Kompetenzen",
            tools: "Tools",
            projects: "Projekte",
            blog: "Blog",
            games: "Spiele",
            chat: "Chat",
            docs: "Dokumentation",
            contact: "Kontakt"
        },
        themeToggle: {
            light: "Zum hellen Modus wechseln",
            dark: "Zum dunklen Modus wechseln"
        },
        blog: {
            title: "Blog",
            subtitle: "Entdecken Sie innovative Analysen und praxisnahe Leitfäden",
            searchPlaceholder: "Artikel suchen...",
            searchButton: "Suchen",
            filterAll: "Alle",
            loading: "Artikel werden geladen...",
            noResults: "Keine Artikel gefunden",
            clearFilters: "Filter zurücksetzen",
            tags: {
                "developpement-web": "Webentwicklung",
                "intelligence-artificielle": "Künstliche Intelligenz",
                "machine-learning": "Maschinelles Lernen",
                ia: "KI",
                developpement: "Entwicklung",
                "revue-de-code": "Code-Review",
                productivite: "Produktivität",
                outils: "Tools",
                startups: "Start-ups",
                technologie: "Technologie",
                innovation: "Innovation",
                durabilite: "Nachhaltigkeit",
                fintech: "Fintech",
                react: "React",
                pwa: "Progressive Web Apps",
                microservices: "Microservices",
                "technologie-moderne": "Moderne Technologie",
                css: "CSS",
                "web-design": "Webdesign",
                "responsive-design": "Responsive Design",
                "grid-layout": "Grid-Layout",
                reglementations: "Vorschriften",
                tech: "Tech",
                "vie-privee": "Datenschutz",
                donnees: "Daten"
            }
        },
        blogPost: {
            backToBlog: "Zurück zum Blog",
            readMore: "Weitere Artikel lesen",
            availableLanguagesTitle: "In anderen Sprachen verfügbar",
            originalBadge: "Original",
            tableOfContentsTitle: "Inhaltsverzeichnis",
            keywords: "Schlüsselwörter",
            date: "Datum",
            readingTime: "Min. Lesezeit",
            views: "Aufrufe",
            share: {
                title: "Artikel teilen",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "E-Mail",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "Nativ teilen",
                copy: "Link kopieren",
                errorNoUrlTitle: "Teilen nicht möglich",
                errorNoUrlDescription: "Die Artikel-URL konnte nicht ermittelt werden.",
                errorWindowTitle: "Freigabe fehlgeschlagen",
                errorWindowDescription: "Das Freigabefenster konnte nicht geöffnet werden.",
                copySuccessTitle: "Link kopiert",
                copySuccessDescription: "Der Artikel-Link wurde in die Zwischenablage kopiert.",
                copyErrorTitle: "Kopieren fehlgeschlagen",
                copyErrorDescription: "Bitte erneut versuchen oder die Adresse manuell kopieren."
            },
            newsletter: {
                badge: "Immer informiert",
                title: "Inspirieren Sie Ihre Projekte 2025-2026",
                description: "Wöchentliche Einblicke in französische Tech-Trends, KI-Tools und praxisnahe Taktiken zur Beschleunigung Ihrer Produkte.",
                namePlaceholder: "Ihr Vorname (optional)",
                emailPlaceholder: "ihre.email@beispiel.de",
                buttonIdle: "Abonnieren",
                buttonLoading: "Abonniere...",
                infoDefault: "Kein Spam – nur kompakte Insights und Tools für Ihre Vorhaben 2025-2026. Abmeldung jederzeit möglich.",
                infoSuccess: "Vielen Dank! Bitte prüfen Sie Ihr Postfach zur Bestätigung.",
                toastMissingEmailTitle: "E-Mail erforderlich",
                toastMissingEmailDescription: "Bitte geben Sie eine gültige E-Mail-Adresse an, um Updates zu erhalten.",
                toastSuccessTitle: "Willkommen im Newsletter!",
                toastSuccessDescription: "Sie erhalten in Kürze unsere neuesten Artikel und Insights.",
                toastErrorTitle: "Anmeldung fehlgeschlagen",
                toastErrorDescription: "Bitte versuchen Sie es in wenigen Minuten erneut."
            }
        },
        articleReader: {
            title: "Artikel anhören",
            loading: "Lädt...",
            voiceLabel: "Stimme",
            femaleVoice: "Weiblich",
            maleVoice: "Männlich",
            volumeLabel: "Lautstärke",
            poweredBy: "Nukoe Sprachtranskription"
        }
    },
    it: {
        cvLinkText: "Guarda il mio CV",
        visitText: "Visita",
        heroTitle: "Mickael Saidi, Sviluppatore Full-Stack (Front-end e Back-end)",
        heroSubtitle: "Sviluppo ogni tipo di applicazione web",
        presentationTitle: "Ciao, sono Mickael: benvenuto nel mio portfolio!",
        presentationText: "Laureato con un Master in ingegneria del software, sto cercando un'azienda in cui mettere a frutto le mie competenze di sviluppo. Sono appassionato di informatica da oltre dieci anni, con un forte interesse per il web.",
        skillsTitle: "Competenze",
        toolsTitle: "Strumenti che utilizzo nella maggior parte dei progetti",
        projectsTitle: "Le aziende per cui ho lavorato",
        documentationTitle: "Documentazioni (PDF)",
        seemoreText: "Vuoi saperne di più?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Linguaggi / Tecnologie padroneggiate",
        projetsText: "Le aziende per cui ho lavorato",
        docDescription1: "Questa documentazione può essere la base per progettare un sistema sicuro e crittografato.",
        docDescription2: "Una panoramica dei più comuni attacchi informatici ai siti web.",
        docDescription3: "I metodi biometrici sono sempre più usati per la sicurezza di sistemi informatici e siti web.",
        company1: "Sviluppo avanzato e ottimizzazione di applicazioni PHP (Symfony), integrando tecnologie di scalabilità come AWS e DynamoDB. Miglioramento e refactoring di moduli esistenti in Symfony e Angular per ottimizzare le prestazioni e la manutenibilità del codice. Progettazione e integrazione di un sistema di personalizzazione avanzato che consente la modifica dinamica dei colori del sito. Modernizzazione dell'architettura per rafforzare la stabilità e la scalabilità delle piattaforme applicative.",
        company2: "Progettazione e sviluppo di una piattaforma web dedicata alla gestione di moduli dinamici, ispirata a TypeForm, utilizzando Symfony 4, PHP e JavaScript. Implementazione di test funzionali avanzati con PHPUnit per garantire stabilità, affidabilità e qualità complessiva della piattaforma e della sua architettura applicativa.",
        company3: "Sviluppo di soluzioni web personalizzate utilizzando Symfony/Laravel, inclusa l'integrazione di API REST e implementazione front-end. Automazione della distribuzione con Docker e GitLab CI/CD, riducendo gli errori umani e accelerando i rilasci di produzione. Ottimizzazione del database (MySQL, PostgreSQL), ottenendo una riduzione del 50% del tempo di esecuzione delle query SQL. Consulenza tecnica e supporto su scalabilità e riprogettazione di architetture legacy per vari clienti.",
        company4: "Sviluppo di soluzioni personalizzate in PHP, SQL, HTML, CSS, JavaScript e jQuery. Contributo attivo al miglioramento continuo e all'evoluzione di un framework proprietario, garantendone stabilità, scalabilità e compatibilità con le tecnologie emergenti del mercato.",
        company5: "Sviluppo e integrazione di interfacce utente interattive e dinamiche in AngularJS, sfruttando HTML, CSS e Bootstrap per garantire un'esperienza utente fluida e responsive. Implementazione delle migliori pratiche front-end per garantire prestazioni, manutenibilità e compatibilità multipiattaforma.",
        company6: "Nel 2012 ho creato un provider VPS distribuendo un server dedicato con protezione DDoS da 10 Gbps.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Linguaggi / Tecnologie padroneggiate",
        machineLearningTitle: "Machine Learning",
        frameworksTitle: "Framework / Librerie",
        toolsSubtitle: "Strumenti professionali che uso per dare vita alle idee",
        projectsSubtitle: "Percorso professionale attraverso aziende innovative e progetti stimolanti",
        documentationSubtitle: "Documentazione tecnica e ricerche su cybersecurity e architetture di sistema",
        contactSubtitle: "Pronto a dare vita al tuo prossimo progetto? Collaboriamo e creiamo qualcosa di straordinario.",
        contactGetInTouch: "Contattami",
        contactFollowMe: "Seguimi",
        contactSendMessage: "Invia un messaggio",
        contactAvailable: "Disponibile per progetti",
        contactAvailableDesc: "Attualmente aperto a nuovi progetti freelance e opportunità full-time. Tempo di risposta: 24-48 ore.",
        contactNameLabel: "Nome",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Oggetto",
        contactMessageLabel: "Messaggio",
        contactNamePlaceholder: "Il tuo nome completo",
        contactEmailPlaceholder: "la.tua.email@esempio.com",
        contactSubjectPlaceholder: "Richiesta progetto, collaborazione, ecc.",
        contactMessagePlaceholder: "Descrivi il tuo progetto, requisiti, tempistiche e budget...",
        contactSendButton: "Invia messaggio",
        contactSendingButton: "Invio...",
        contactErrorTitle: "Invio non riuscito",
        contactErrorMessage: "Si è verificato un errore durante l'invio del messaggio. Riprova più tardi.",
        contactTimeoutMessage: "Timeout della richiesta. Controlla la connessione e riprova.",
        footerMadeWith: "Creato con",
        footerPoweredBy: "powered by",
        footerRights: "Tutti i diritti riservati.",
        footerBuiltWith: "Costruito con React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Anni di esperienza",
        statsProjectsDone: "Progetti completati",
        statsUsersReached: "Utenti raggiunti",
        statsProjectsCompleted: "Progetti conclusi",
        statsUsersImpacted: "Utenti impattati",
        statsTechMastered: "Tecnologie padroneggiate",
        developmentCategory: "Sviluppo",
        databasesCategory: "Database",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Design",
        testingCategory: "Test & QA",
        buildToolsCategory: "Strumenti di build",
        coreStackTitle: "Stack tecnologico principale",
        docLibraryTitle: "Libreria di documentazione tecnica",
        docLibraryDesc: "Questi documenti rappresentano anni di ricerca ed esperienza pratica in cybersecurity, architetture di sistema e sistemi di autenticazione moderni. Ogni documento offre approfondimenti, linee guida di implementazione e best practice per soluzioni enterprise.",
        docTotalPages: "Pagine totali",
        docResearchPapers: "Paper di ricerca",
        docEnterpriseReady: "Pronto per l'impresa",
        downloadPdf: "Scarica PDF",
        preview: "Anteprima",
        pages: "pagine",
        missingInfo: "Informazioni mancanti",
        fillRequired: "Compila tutti i campi obbligatori.",
        messageSent: "Messaggio inviato!",
        messageThankYou: "Grazie per il tuo messaggio, ti ricontatterò a breve.",
        messageReceived: "Ti risponderò entro 24-48 ore.",
        menu: {
            skills: "Competenze",
            tools: "Strumenti",
            projects: "Progetti",
            blog: "Blog",
            games: "Giochi",
            chat: "Chat",
            docs: "Documenti",
            contact: "Contatti"
        },
        themeToggle: {
            light: "Passa alla modalità chiara",
            dark: "Passa alla modalità scura"
        },
        blog: {
            title: "Blog",
            subtitle: "Scopri analisi innovative e guide pratiche",
            searchPlaceholder: "Cerca articoli...",
            searchButton: "Cerca",
            filterAll: "Tutti",
            loading: "Caricamento articoli...",
            noResults: "Nessun articolo trovato",
            clearFilters: "Annulla filtri",
            tags: {
                "developpement-web": "Sviluppo web",
                "intelligence-artificielle": "Intelligenza artificiale",
                "machine-learning": "Apprendimento automatico",
                ia: "IA",
                developpement: "Sviluppo",
                "revue-de-code": "Revisione del codice",
                productivite: "Produttività",
                outils: "Strumenti",
                startups: "Startup",
                technologie: "Tecnologia",
                innovation: "Innovazione",
                durabilite: "Sostenibilità",
                fintech: "Fintech",
                react: "React",
                pwa: "Applicazioni web progressive",
                microservices: "Microservizi",
                "technologie-moderne": "Tecnologia moderna",
                css: "CSS",
                "web-design": "Web design",
                "responsive-design": "Design responsive",
                "grid-layout": "Layout a griglia",
                reglementations: "Regolamentazioni",
                tech: "Tech",
                "vie-privee": "Privacy",
                donnees: "Dati"
            }
        },
        blogPost: {
            backToBlog: "Torna al blog",
            readMore: "Leggi altri articoli",
            availableLanguagesTitle: "Disponibile in altre lingue",
            originalBadge: "Originale",
            tableOfContentsTitle: "Sommario",
            keywords: "Parole chiave",
            date: "Data",
            readingTime: "min di lettura",
            views: "visualizzazioni",
            share: {
                title: "Condividi l'articolo",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "Email",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "Condividi nativamente",
                copy: "Copia link",
                errorNoUrlTitle: "Condivisione non disponibile",
                errorNoUrlDescription: "Non è stato possibile recuperare l'URL dell'articolo.",
                errorWindowTitle: "Condivisione fallita",
                errorWindowDescription: "Non è stato possibile aprire la finestra di condivisione.",
                copySuccessTitle: "Link copiato",
                copySuccessDescription: "Il link dell'articolo è stato copiato negli appunti.",
                copyErrorTitle: "Copiatura fallita",
                copyErrorDescription: "Riprova o copia manualmente l'indirizzo."
            },
            newsletter: {
                badge: "Rimani aggiornato",
                title: "Ispira i tuoi progetti 2025-2026",
                description: "Un digest settimanale con trend tech francesi, strumenti AI e tattiche pratiche per accelerare i tuoi prodotti.",
                namePlaceholder: "Il tuo nome (opzionale)",
                emailPlaceholder: "la.tua.email@esempio.com",
                buttonIdle: "Iscriviti",
                buttonLoading: "Iscrizione in corso...",
                infoDefault: "Niente spam: solo insight sintetici e strumenti pronti all'uso per le tue iniziative 2025-2026. Cancellazione in qualsiasi momento.",
                infoSuccess: "Grazie! Controlla la tua casella di posta per confermare l'iscrizione.",
                toastMissingEmailTitle: "Email obbligatoria",
                toastMissingEmailDescription: "Inserisci un'email valida per ricevere gli aggiornamenti.",
                toastSuccessTitle: "Benvenuto nella newsletter!",
                toastSuccessDescription: "Riceverai presto i nostri nuovi articoli e approfondimenti.",
                toastErrorTitle: "Iscrizione fallita",
                toastErrorDescription: "Riprova tra qualche istante."
            }
        },
        articleReader: {
            title: "Ascolta l'articolo",
            loading: "Caricamento...",
            voiceLabel: "Voce",
            femaleVoice: "Femminile",
            maleVoice: "Maschile",
            volumeLabel: "Volume",
            speedLabel: "Speed",            poweredBy: "Nukoe Trascrizione Vocale"
        }
    },
    fr: {
        cvLinkText: "Voir mon CV",
        visitText: "Visiter",
        heroTitle: "Mickael Saidi, Développeur Full-stack (Front-end et Back-end)",
        heroSubtitle: "Je développe tous types d'applications web",
        presentationTitle: "Bonjour, je m'appelle Mickael, bienvenue dans mon portfolio !",
        presentationText: "Diplômé d'un Master en ingénierie logicielle, je cherche actuellement une entreprise pour appliquer mes compétences en développement. Passionné par l'informatique depuis plus d'une décennie, le développement web m'a toujours fasciné.",
        skillsTitle: "Compétences",
        toolsTitle: "Les outils que j'utilise pour la plupart de mes projets",
        projectsTitle: "Les entreprises pour lesquelles j'ai travaillé",
        documentationTitle: "Documentations (PDF)",
        seemoreText: "Vous voulez en savoir plus ?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Langues / Technologies maîtrisées",
        projetsText: "Les entreprises pour lesquelles j'ai travaillé",
        docDescription1: "Cette documentation peut servir de base pour la conception d'un système sécurisé et crypté.",
        docDescription2: "Une grande partie des attaques cybernétiques les plus courantes sur les sites web.",
        docDescription3: "Les moyens biométriques sont de plus en plus utilisés pour la sécurité des systèmes informatiques et des sites web.",
        company1: "Développement et optimisation avancée d'applications en PHP (Symfony), intégrant des technologies de scalabilité comme AWS et DynamoDB. Amélioration et refonte des modules existants sous Symfony et Angular afin d'optimiser la performance et la maintenabilité du code. Conception et intégration d'un système de personnalisation avancée, permettant une modification dynamique des couleurs du site. Modernisation des architectures pour renforcer la stabilité et la scalabilité des plateformes applicatives.",
        company2: "Conception et développement d'une plateforme web dédiée à la gestion de formulaires dynamiques, inspirée de TypeForm, en exploitant Symfony 4, PHP et JavaScript. Implémentation de tests fonctionnels avancés avec PHPUnit afin d'assurer la stabilité, la fiabilité et la qualité globale de la plateforme et de son architecture applicative.",
        company3: "Développement de solutions web sur-mesure en Symfony / Laravel, avec intégration API REST et front-end. Automatisation des déploiements via Docker et GitLab CI/CD, réduisant les erreurs humaines et accélérant la mise en production. Optimisation des bases de données (MySQL, PostgreSQL) avec une réduction du temps d'exécution des requêtes SQL de 50%. Conseil et accompagnement technique sur la scalabilité et la refonte d'architectures legacy pour divers clients.",
        company4: "Développement de solutions sur-mesure en PHP, SQL, HTML, CSS, JavaScript et jQuery. Contribution active à l'amélioration continue et à l'évolution d'un framework propriétaire, garantissant sa stabilité, sa scalabilité ainsi que sa compatibilité avec les technologies émergentes du marché.",
        company5: "Développement et intégration d'interfaces utilisateur interactives et dynamiques sous AngularJS, en exploitant HTML, CSS et Bootstrap pour assurer une expérience utilisateur fluide et responsive. Mise en œuvre des meilleures pratiques front-end afin de garantir performance, maintenabilité et compatibilité multi-plateformes.",
        company6: "Création en 2012 d'un fournisseur de services VPS (Serveur privé virtuel) en dispatchant un serveur dédié avec protection DDoS de 10gbps.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Langues / Technologies maîtrisées",
        machineLearningTitle: "Apprentissage automatique",
        frameworksTitle: "Frameworks / Bibliothèques",
        // Value Proposition
        valuePropositionTitle: "Pourquoi travailler avec moi ?",
        valuePropositionSubtitle: "Excellence et expertise éprouvée, combinées aux technologies de pointe",
        valuePropositionFastTitle: "Livraison Rapide",
        valuePropositionFastDesc: "Architecture solide dès le premier jour. Code propre, scalable et maintenable qui résiste à l'épreuve du temps.",
        valuePropositionSecurityTitle: "Sécurité Enterprise",
        valuePropositionSecurityDesc: "Expert en cybersécurité. Vos données et celles de vos utilisateurs sont protégées par des pratiques de niveau professionnel.",
        valuePropositionTechTitle: "Stack Moderne",
        valuePropositionTechDesc: "React, TypeScript, Symfony, AWS. Technologies éprouvées pour des applications qui passent à l'échelle.",
        // Case Studies
        caseStudiesTitle: "Projets Phares",
        caseStudiesSubtitle: "Résultats concrets face à des défis réels",
        caseStudyBadge: "Étude de Cas",
        caseStudyMetricUsers: "Utilisateurs",
        caseStudyMetricPerformance: "Plus Rapide",
        caseStudyMetricConversion: "Conversion",
        // Final CTA
        finalCtaTitle: "Prêt à lancer votre projet ?",
        finalCtaSubtitle: "Réponse garantie sous 24 heures",
        finalCtaPrimary: "Discutons de votre projet",
        finalCtaSecondary: "Télécharger mon CV",
        // Updated Hero
        heroTitleNew: "Je transforme vos idées en applications web performantes",
        heroSubtitleNew: "Développeur Full-Stack • 13+ ans • 50+ projets • 120k+ utilisateurs impactés",
        heroCtaMain: "Voir mes réalisations",
        // Skills Compact
        skillsCompactTitle: "Stack Technique",
        skillsCompactExpand: "Voir toutes les compétences",
        skillsCompactCollapse: "Voir moins",
        // Additional French translations
        toolsSubtitle: "Outils et technologies professionnels que j'utilise pour donner vie aux idées",
        projectsSubtitle: "Parcours professionnel à travers des entreprises innovantes et des projets stimulants",
        documentationSubtitle: "Documentation technique et articles de recherche sur la cybersécurité et l'architecture système",
        contactSubtitle: "Prêt à donner vie à votre prochain projet ? Collaborons et créons quelque chose d'extraordinaire ensemble.",
        contactGetInTouch: "Contactez-moi",
        contactFollowMe: "Suivez-moi",
        contactSendMessage: "Envoyer un message",
        contactAvailable: "Disponible pour des projets",
        contactAvailableDesc: "J'accepte actuellement de nouveaux projets freelance et des opportunités à temps plein. Délai de réponse : 24-48 heures.",
        contactNameLabel: "Nom",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Sujet",
        contactMessageLabel: "Message",
        contactNamePlaceholder: "Votre nom complet",
        contactEmailPlaceholder: "votre.email@exemple.com",
        contactSubjectPlaceholder: "Demande de projet, collaboration, etc.",
        contactMessagePlaceholder: "Parlez-moi de votre projet, exigences, délais et budget...",
        contactSendButton: "Envoyer le message",
        contactSendingButton: "Envoi...",
        contactErrorTitle: "Erreur lors de l'envoi",
        contactErrorMessage: "Une erreur est survenue pendant l'envoi du message. Veuillez réessayer.",
        contactTimeoutMessage: "La requête a expiré. Vérifiez votre connexion et réessayez.",
        footerMadeWith: "Créé avec",
        footerPoweredBy: "alimenté par",
        footerRights: "Tous droits réservés.",
        footerBuiltWith: "Construit avec React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Années d'expérience",
        statsProjectsDone: "Projets réalisés",
        statsUsersReached: "Utilisateurs touchés",
        statsProjectsCompleted: "Projets terminés",
        statsUsersImpacted: "Utilisateurs impactés",
        statsTechMastered: "Technologies maîtrisées",
        developmentCategory: "Développement",
        databasesCategory: "Bases de données",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Design",
        testingCategory: "Tests & QA",
        buildToolsCategory: "Outils de build",
        coreStackTitle: "Stack technologique principal",
        docLibraryTitle: "Bibliothèque de documentation technique",
        docLibraryDesc: "Ces documents complets représentent des années de recherche et d'expérience pratique en cybersécurité, architecture système et systèmes d'authentification modernes. Chaque article fournit des informations détaillées, des directives d'implémentation et les meilleures pratiques pour les solutions d'entreprise.",
        docTotalPages: "Pages totales",
        docResearchPapers: "Articles de recherche",
        docEnterpriseReady: "Prêt pour l'entreprise",
        downloadPdf: "Télécharger PDF",
        preview: "Aperçu",
        pages: "pages",
        missingInfo: "Information manquante",
        fillRequired: "Veuillez remplir tous les champs obligatoires.",
        messageSent: "Message envoyé !",
        messageThankYou: "Merci pour votre message. Je vous répondrai bientôt.",
        menu: {
            skills: "Compétences",
            tools: "Outils",
            projects: "Projets",
            blog: "Blog",
            games: "Jeux",
            chat: "Chat",
            docs: "Docs",
            contact: "Contact"
        },
        themeToggle: {
            light: "Passer en mode clair",
            dark: "Passer en mode sombre"
        },
        blog: {
            title: "Blog",
            subtitle: "Découvrez des analyses innovantes et des guides pratiques",
            searchPlaceholder: "Rechercher des articles...",
            searchButton: "Rechercher",
            filterAll: "Tous",
            loading: "Chargement des articles...",
            noResults: "Aucun article trouvé",
            clearFilters: "Réinitialiser les filtres",
            tags: {
                "developpement-web": "Développement Web",
                "intelligence-artificielle": "Intelligence artificielle",
                "machine-learning": "Apprentissage automatique",
                ia: "IA",
                developpement: "Développement",
                "revue-de-code": "Revue de code",
                productivite: "Productivité",
                outils: "Outils",
                startups: "Startups",
                technologie: "Technologie",
                innovation: "Innovation",
                durabilite: "Durabilité",
                fintech: "Fintech",
                react: "React",
                pwa: "Applications web progressives",
                microservices: "Microservices",
                "technologie-moderne": "Technologie moderne",
                css: "CSS",
                "web-design": "Web design",
                "responsive-design": "Responsive design",
                "grid-layout": "Mise en page en grille",
                reglementations: "Réglementations",
                tech: "Tech",
                "vie-privee": "Vie privée",
                donnees: "Données"
            }
        },
        blogPost: {
            backToBlog: "Retour au blog",
            readMore: "Découvrir d'autres articles",
            availableLanguagesTitle: "Disponible dans d'autres langues",
            originalBadge: "Original",
            tableOfContentsTitle: "Sommaire",
            keywords: "Mots-clés",
            date: "Date",
            readingTime: "min de lecture",
            views: "vues",
            share: {
                title: "Partager cet article",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "E-mail",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "Partager via votre appareil",
                copy: "Copier le lien",
                errorNoUrlTitle: "Partage indisponible",
                errorNoUrlDescription: "Impossible de récupérer l'URL de l'article.",
                errorWindowTitle: "Partage impossible",
                errorWindowDescription: "Nous n'avons pas pu ouvrir la fenêtre de partage.",
                copySuccessTitle: "Lien copié",
                copySuccessDescription: "Le lien de l’article est maintenant dans votre presse-papiers.",
                copyErrorTitle: "Échec de la copie",
                copyErrorDescription: "Veuillez réessayer ou partager l’adresse manuellement."
            },
            newsletter: {
                badge: "Restez en avance",
                title: "Inspirez vos projets 2025-2026",
                description: "Recevez chaque semaine une synthèse des tendances tech françaises, des outils IA et des approches concrètes pour accélérer vos produits.",
                namePlaceholder: "Votre prénom (optionnel)",
                emailPlaceholder: "votre.email@exemple.com",
                buttonIdle: "Je m'inscris",
                buttonLoading: "Inscription...",
                infoDefault: "Pas de spam, uniquement des analyses pertinentes et des outils prêts à l’emploi pour vos initiatives 2025-2026. Vous pouvez vous désinscrire en un clic.",
                infoSuccess: "Merci ! Vous êtes maintenant inscrit·e. Vérifiez votre boîte mail pour confirmer votre abonnement.",
                toastMissingEmailTitle: "Adresse e-mail requise",
                toastMissingEmailDescription: "Merci d'indiquer une adresse valide pour recevoir nos actualités.",
                toastSuccessTitle: "Bienvenue dans la newsletter !",
                toastSuccessDescription: "Vous recevrez bientôt nos prochains articles et analyses 2025-2026.",
                toastErrorTitle: "Échec de l'inscription",
                toastErrorDescription: "Merci de réessayer dans quelques instants."
            }
        },
        articleReader: {
            title: "Écouter l'article",
            loading: "Chargement...",
            voiceLabel: "Voix",
            femaleVoice: "Féminine",
            maleVoice: "Masculine",
            volumeLabel: "Volume",
            speedLabel: "Speed",            poweredBy: "Nukoe Transcription Vocale"
        }
    },
    es: {
        cvLinkText: "Ver mi CV",
        visitText: "Visitar",
        heroTitle: "Mickael Saidi, Desarrollador Full-stack (Front-end y Back-end)",
        heroSubtitle: "Desarrollo todo tipo de aplicaciones web",
        presentationTitle: "Hola, mi nombre es Mickael, ¡bienvenido a mi portafolio!",
        presentationText: "Graduado con una maestría en ingeniería de software, actualmente busco una empresa para aplicar mis habilidades de desarrollo. Apasionado por las computadoras durante más de una década, el desarrollo web siempre me ha fascinado.",
        skillsTitle: "Habilidades",
        toolsTitle: "Las herramientas que uso para la mayoría de mis proyectos",
        projectsTitle: "Las empresas para las que he trabajado",
        documentationTitle: "Documentaciones (PDF)",
        seemoreText: "¿Quieres saber más?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Lenguajes / Tecnologías dominadas",
        projetsText: "Las empresas para las que he trabajado",
        docDescription1: "Esta documentación puede servir como base para diseñar un sistema seguro y cifrado.",
        docDescription2: "Una gran parte de los ataques cibernéticos más comunes a los sitios web.",
        docDescription3: "Los medios biométricos se utilizan cada vez más para la seguridad de los sistemas informáticos y los sitios web.",
        company1: "Desarrollo avanzado y optimización de aplicaciones PHP (Symfony), integrando tecnologías de escalabilidad como AWS y DynamoDB. Mejora y refactorización de módulos existentes en Symfony y Angular para optimizar el rendimiento y la mantenibilidad del código. Diseño e integración de un sistema de personalización avanzado que permite la modificación dinámica de los colores del sitio. Modernización de arquitecturas para reforzar la estabilidad y escalabilidad de las plataformas aplicativas.",
        company2: "Diseño y desarrollo de una plataforma web dedicada a la gestión de formularios dinámicos, inspirada en TypeForm, utilizando Symfony 4, PHP y JavaScript. Implementación de pruebas funcionales avanzadas con PHPUnit para garantizar la estabilidad, fiabilidad y calidad general de la plataforma y su arquitectura aplicativa.",
        company3: "Desarrollo de soluciones web a medida utilizando Symfony/Laravel, incluyendo integración de API REST e implementación front-end. Automatización de despliegues mediante Docker y GitLab CI/CD, reduciendo errores humanos y acelerando los lanzamientos de producción. Optimización de bases de datos (MySQL, PostgreSQL), logrando una reducción del 50% en el tiempo de ejecución de consultas SQL. Asesoramiento técnico y soporte en escalabilidad y rediseño de arquitecturas legacy para diversos clientes.",
        company4: "Desarrollo de soluciones personalizadas en PHP, SQL, HTML, CSS, JavaScript y jQuery. Contribución activa a la mejora continua y evolución de un framework propietario, garantizando su estabilidad, escalabilidad y compatibilidad con las tecnologías emergentes del mercado.",
        company5: "Desarrollo e integración de interfaces de usuario interactivas y dinámicas en AngularJS, aprovechando HTML, CSS y Bootstrap para garantizar una experiencia de usuario fluida y responsive. Implementación de las mejores prácticas front-end para garantizar rendimiento, mantenibilidad y compatibilidad multiplataforma.",
        company6: "Creación en 2012 de un proveedor de servicios VPS (Servidor privado virtual) mediante la distribución de un servidor dedicado con protección DDoS de 10gbps.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Lenguajes / Tecnologías dominadas",
        machineLearningTitle: "Aprendizaje automático",
        frameworksTitle: "Frameworks / Bibliotecas",
        // Additional Spanish translations
        toolsSubtitle: "Herramientas y tecnologías profesionales que uso para dar vida a las ideas",
        projectsSubtitle: "Trayectoria profesional a través de empresas innovadoras y proyectos desafiantes",
        documentationSubtitle: "Documentación técnica e investigación sobre ciberseguridad y arquitectura de sistemas",
        contactSubtitle: "¿Listo para dar vida a tu próximo proyecto? Colaboremos y creemos algo increíble juntos.",
        contactGetInTouch: "Ponte en contacto",
        contactFollowMe: "Sígueme",
        contactSendMessage: "Enviar mensaje",
        contactAvailable: "Disponible para proyectos",
        contactAvailableDesc: "Actualmente acepto nuevos proyectos freelance y oportunidades de tiempo completo. Tiempo de respuesta: 24-48 horas.",
        contactNameLabel: "Nombre",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Asunto",
        contactMessageLabel: "Mensaje",
        contactNamePlaceholder: "Tu nombre completo",
        contactEmailPlaceholder: "tu.email@ejemplo.com",
        contactSubjectPlaceholder: "Consulta de proyecto, colaboración, etc.",
        contactMessagePlaceholder: "Cuéntame sobre tu proyecto, requisitos, cronograma y presupuesto...",
        contactSendButton: "Enviar mensaje",
        contactSendingButton: "Enviando...",
        contactErrorTitle: "Error al enviar",
        contactErrorMessage: "Ocurrió un error al enviar tu mensaje. Inténtalo de nuevo más tarde.",
        contactTimeoutMessage: "La solicitud excedió el tiempo de espera. Verifica tu conexión e inténtalo nuevamente.",
        footerMadeWith: "Hecho con",
        footerPoweredBy: "impulsado por",
        footerRights: "Todos los derechos reservados.",
        footerBuiltWith: "Construido con React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Años de experiencia",
        statsProjectsDone: "Proyectos realizados",
        statsUsersReached: "Usuarios alcanzados",
        statsProjectsCompleted: "Proyectos completados",
        statsUsersImpacted: "Usuarios impactados",
        statsTechMastered: "Tecnologías dominadas",
        developmentCategory: "Desarrollo",
        databasesCategory: "Bases de datos",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Diseño",
        testingCategory: "Pruebas & QA",
        buildToolsCategory: "Herramientas de build",
        coreStackTitle: "Stack tecnológico principal",
        docLibraryTitle: "Biblioteca de documentación técnica",
        docLibraryDesc: "Estos documentos completos representan años de investigación y experiencia práctica en ciberseguridad, arquitectura de sistemas y sistemas de autenticación modernos. Cada artículo proporciona información detallada, pautas de implementación y mejores prácticas para soluciones empresariales.",
        docTotalPages: "Páginas totales",
        docResearchPapers: "Artículos de investigación",
        docEnterpriseReady: "Listo para empresa",
        downloadPdf: "Descargar PDF",
        preview: "Vista previa",
        pages: "páginas",
        missingInfo: "Información faltante",
        fillRequired: "Por favor, complete todos los campos obligatorios.",
        messageSent: "¡Mensaje enviado!",
        messageThankYou: "Gracias por tu mensaje. Te responderé pronto.",
        menu: {
            skills: "Habilidades",
            tools: "Herramientas",
            projects: "Proyectos",
            blog: "Blog",
            games: "Juegos",
            chat: "Chat",
            docs: "Documentos",
            contact: "Contacto"
        },
        themeToggle: {
            light: "Cambiar a modo claro",
            dark: "Cambiar a modo oscuro"
        },
        blog: {
            title: "Blog",
            subtitle: "Descubre análisis innovadores y guías prácticas",
            searchPlaceholder: "Buscar artículos...",
            searchButton: "Buscar",
            filterAll: "Todos",
            loading: "Cargando artículos...",
            noResults: "No se encontraron artículos",
            clearFilters: "Limpiar filtros",
            tags: {
                "developpement-web": "Desarrollo web",
                "intelligence-artificielle": "Inteligencia artificial",
                "machine-learning": "Aprendizaje automático",
                ia: "IA",
                developpement: "Desarrollo",
                "revue-de-code": "Revisión de código",
                productivite: "Productividad",
                outils: "Herramientas",
                startups: "Startups",
                technologie: "Tecnología",
                innovation: "Innovación",
                durabilite: "Sostenibilidad",
                fintech: "Fintech",
                react: "React",
                pwa: "Aplicaciones web progresivas",
                microservices: "Microservicios",
                "technologie-moderne": "Tecnología moderna",
                css: "CSS",
                "web-design": "Diseño web",
                "responsive-design": "Diseño responsive",
                "grid-layout": "Diseño en cuadrícula",
                reglementations: "Regulaciones",
                tech: "Tech",
                "vie-privee": "Privacidad",
                donnees: "Datos"
            }
        },
        blogPost: {
            backToBlog: "Volver al blog",
            readMore: "Ver más artículos",
            availableLanguagesTitle: "Disponible en otros idiomas",
            originalBadge: "Original",
            tableOfContentsTitle: "Tabla de contenidos",
            keywords: "Palabras clave",
            date: "Fecha",
            readingTime: "min de lectura",
            views: "vistas",
            share: {
                title: "Comparte este artículo",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "Email",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "Compartir vía tu dispositivo",
                copy: "Copiar enlace",
                errorNoUrlTitle: "Compartir no disponible",
                errorNoUrlDescription: "No pudimos recuperar la URL del artículo.",
                errorWindowTitle: "No se pudo compartir",
                errorWindowDescription: "No pudimos abrir la ventana de compartir.",
                copySuccessTitle: "Enlace copiado",
                copySuccessDescription: "El enlace del artículo se ha copiado en tu portapapeles.",
                copyErrorTitle: "Error al copiar",
                copyErrorDescription: "Por favor, inténtalo de nuevo o copia la dirección manualmente."
            },
            newsletter: {
                badge: "Mantente a la vanguardia",
                title: "Inspira tus proyectos 2025-2026",
                description: "Recibe cada semana un resumen de las tendencias tecnológicas francesas, herramientas de IA y enfoques prácticos para acelerar tus productos.",
                namePlaceholder: "Tu nombre (opcional)",
                emailPlaceholder: "tu.email@ejemplo.com",
                buttonIdle: "Suscribirme",
                buttonLoading: "Suscribiéndose...",
                infoDefault: "Nada de spam: solo ideas relevantes y herramientas listas para usar para tus iniciativas 2025-2026. Puedes darte de baja en cualquier momento.",
                infoSuccess: "¡Gracias! Revisa tu bandeja de entrada para confirmar tu suscripción.",
                toastMissingEmailTitle: "Correo electrónico requerido",
                toastMissingEmailDescription: "Proporciona una dirección válida para recibir nuestras novedades.",
                toastSuccessTitle: "¡Bienvenido a la newsletter!",
                toastSuccessDescription: "Muy pronto recibirás nuestros artículos y análisis.",
                toastErrorTitle: "Error al suscribirse",
                toastErrorDescription: "Por favor, inténtalo de nuevo en unos segundos."
            }
        },
        articleReader: {
            title: "Escuchar el artículo",
            loading: "Cargando...",
            voiceLabel: "Voz",
            femaleVoice: "Femenina",
            maleVoice: "Masculina",
            volumeLabel: "Volumen",
            speedLabel: "Speed",            poweredBy: "Nukoe Transcripción Vocal"
        }
    },
    ar: {
        cvLinkText: "رؤية سيرتي الذاتية",
        visitText: "زيارة",
        heroTitle: "ميكائيل سعيدي ، مطور كامل المكدس (الواجهة الأمامية والخلفية)",
        heroSubtitle: "أقوم بتطوير جميع أنواع تطبيقات الويب",
        presentationTitle: "مرحبًا ، اسمي ميكائيل ، مرحبًا بك في محفظتي!",
        presentationText: "تخرجت من درجة الماجستير في هندسة البرمجيات ، وأنا حاليًا أبحث عن شركة لتطبيق مهاراتي في التطوير. لطالما كانت تطوير الويب تثير اهتمامي منذ أكثر من عقد.",
        skillsTitle: "المهارات",
        toolsTitle: "الأدوات التي أستخدمها لمعظم مشاريعي",
        projectsTitle: "الشركات التي عملت بها",
        documentationTitle: "الوثائق (PDF)",
        seemoreText: "هل ترغب في معرفة المزيد؟",
        frontendTitle: "واجهة المستخدم",
        masteredTechTitle: "اللغات / التقنيات التي أتقنها",
        projetsText: "الشركات التي عملت بها",
        docDescription1: "يمكن أن تكون هذه الوثيقة أساسًا لتصميم نظام آمن ومشفر.",
        docDescription2: "جزء كبير من أكثر الهجمات الإلكترونية شيوعًا على المواقع.",
        docDescription3: "تستخدم الوسائل البيومترية بشكل متزايد لأمن الأنظمة المعلوماتية والمواقع.",
        company1: "تطوير وتحسين متقدم لتطبيقات PHP (Symfony)، مع دمج تقنيات قابلية التوسع مثل AWS وDynamoDB. تحسين وإعادة هيكلة الوحدات الموجودة في Symfony وAngular لتحسين الأداء وقابلية صيانة الكود. تصميم ودمج نظام تخصيص متقدم يتيح تعديل ألوان الموقع ديناميكياً. تحديث البنية المعمارية لتعزيز الاستقرار وقابلية التوسع لمنصات التطبيقات.",
        company2: "تصميم وتطوير منصة ويب مخصصة لإدارة النماذج الديناميكية، مستوحاة من TypeForm، باستخدام Symfony 4 وPHP وJavaScript. تنفيذ اختبارات وظيفية متقدمة باستخدام PHPUnit لضمان الاستقرار والموثوقية والجودة الشاملة للمنصة وبنيتها التطبيقية.",
        company3: "تطوير حلول ويب مخصصة باستخدام Symfony/Laravel، بما في ذلك تكامل REST API والتنفيذ الأمامي. أتمتة النشر باستخدام Docker وGitLab CI/CD، مما يقلل الأخطاء البشرية ويسرع إصدارات الإنتاج. تحسين قاعدة البيانات (MySQL، PostgreSQL)، مع تحقيق تخفيض بنسبة 50٪ في وقت تنفيذ استعلامات SQL. الاستشارات الفنية والدعم في قابلية التوسع وإعادة تصميم البنى القديمة لمختلف العملاء.",
        company4: "تطوير حلول مخصصة في PHP وSQL وHTML وCSS وJavaScript وjQuery. مساهمة نشطة في التحسين المستمر وتطوير إطار عمل خاص، مما يضمن استقراره وقابليته للتوسع وتوافقه مع التقنيات الناشئة في السوق.",
        company5: "تطوير ودمج واجهات مستخدم تفاعلية وديناميكية في AngularJS، مع الاستفادة من HTML وCSS وBootstrap لضمان تجربة مستخدم سلسة ومتجاوبة. تنفيذ أفضل ممارسات الواجهة الأمامية لضمان الأداء وقابلية الصيانة والتوافق عبر المنصات.",
        company6: "إنشاء مزود خدمة VPS (خادم خاص افتراضي) في عام 2012 من خلال توزيع خادم مخصص مع حماية DDoS بسرعة 10 جيجابت في الثانية.",
        backendTitle: "الواجهة الخلفية",
        masteredBackendTechTitle: "اللغات / التقنيات التي أتقنها",
        machineLearningTitle: "تعلم الآلة",
        frameworksTitle: "الأطر / المكتبات",
        // Additional Arabic translations
        toolsSubtitle: "الأدوات والتقنيات المهنية التي أستخدمها لإحياء الأفكار",
        projectsSubtitle: "رحلة مهنية عبر شركات مبتكرة ومشاريع تحدي",
        documentationSubtitle: "وثائق تقنية وأوراق بحثية حول الأمن السيبراني وهندسة الأنظمة",
        contactSubtitle: "مستعد لإحياء مشروعك القادم؟ دعنا نتعاون وننشئ شيئًا مذهلاً معًا.",
        contactGetInTouch: "تواصل معي",
        contactFollowMe: "تابعني",
        contactSendMessage: "إرسال رسالة",
        contactAvailable: "متاح للمشاريع",
        contactAvailableDesc: "أقبل حاليًا مشاريع العمل الحر الجديدة والفرص بدوام كامل. وقت الاستجابة: 24-48 ساعة.",
        contactNameLabel: "الاسم",
        contactEmailLabel: "البريد الإلكتروني",
        contactSubjectLabel: "الموضوع",
        contactMessageLabel: "الرسالة",
        contactNamePlaceholder: "اسمك الكامل",
        contactEmailPlaceholder: "your.email@example.com",
        contactSubjectPlaceholder: "استفسار المشروع، التعاون، إلخ.",
        contactMessagePlaceholder: "أخبرني عن مشروعك، المتطلبات، الجدول الزمني والميزانية...",
        contactSendButton: "إرسال الرسالة",
        contactSendingButton: "جارٍ الإرسال...",
        contactErrorTitle: "حدث خطأ أثناء الإرسال",
        contactErrorMessage: "حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى لاحقًا.",
        contactTimeoutMessage: "انتهت مهلة الطلب. يرجى التحقق من الاتصال والمحاولة مرة أخرى.",
        footerMadeWith: "صُنع بـ",
        footerPoweredBy: "مدعوم بـ",
        footerRights: "جميع الحقوق محفوظة.",
        footerBuiltWith: "مبني باستخدام React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "سنوات الخبرة",
        statsProjectsDone: "المشاريع المنجزة",
        statsUsersReached: "المستخدمون الذين تم الوصول إليهم",
        statsProjectsCompleted: "المشاريع المكتملة",
        statsUsersImpacted: "المستخدمون المتأثرون",
        statsTechMastered: "التقنيات المتقنة",
        developmentCategory: "التطوير",
        databasesCategory: "قواعد البيانات",
        cloudDevOpsCategory: "السحابة والتطوير",
        designCategory: "التصميم",
        testingCategory: "الاختبار وضمان الجودة",
        buildToolsCategory: "أدوات البناء",
        coreStackTitle: "المكدس التقني الأساسي",
        docLibraryTitle: "مكتبة التوثيق التقني",
        docLibraryDesc: "تمثل هذه الوثائق الشاملة سنوات من البحث والخبرة العملية في الأمن السيبراني وهندسة الأنظمة وأنظمة المصادقة الحديثة. توفر كل ورقة رؤى مفصلة وإرشادات التنفيذ وأفضل الممارسات للحلول على مستوى المؤسسة.",
        docTotalPages: "إجمالي الصفحات",
        docResearchPapers: "أوراق البحث",
        docEnterpriseReady: "جاهز للمؤسسة",
        downloadPdf: "تحميل PDF",
        preview: "معاينة",
        pages: "صفحات",
        missingInfo: "معلومات مفقودة",
        fillRequired: "يرجى ملء جميع الحقول المطلوبة.",
        messageSent: "تم إرسال الرسالة!",
        messageThankYou: "شكرًا لك على رسالتك. سأرد عليك قريبًا.",
        menu: {
            skills: "المهارات",
            tools: "الأدوات",
            projects: "المشاريع",
            blog: "مدونة",
            games: "الألعاب",
            chat: "دردشة",
            docs: "الوثائق",
            contact: "اتصل"
        },
        themeToggle: {
            light: "التبديل إلى الوضع الفاتح",
            dark: "التبديل إلى الوضع المظلم"
        },
        blog: {
            title: "المدونة",
            subtitle: "اكتشف رؤى متطورة وأدلة عملية",
            searchPlaceholder: "ابحث عن المقالات...",
            searchButton: "بحث",
            filterAll: "الكل",
            loading: "جارٍ تحميل المقالات...",
            noResults: "لم يتم العثور على مقالات",
            clearFilters: "مسح عوامل التصفية",
            tags: {
                "developpement-web": "تطوير الويب",
                "intelligence-artificielle": "الذكاء الاصطناعي",
                "machine-learning": "تعلّم الآلة",
                ia: "ذكاء اصطناعي",
                developpement: "تطوير",
                "revue-de-code": "مراجعة الشفرة",
                productivite: "الإنتاجية",
                outils: "أدوات",
                startups: "الشركات الناشئة",
                technologie: "تكنولوجيا",
                innovation: "ابتكار",
                durabilite: "الاستدامة",
                fintech: "فينتك",
                react: "React",
                pwa: "تطبيقات ويب تقدمية",
                microservices: "خدمات مصغرة",
                "technologie-moderne": "تكنولوجيا حديثة",
                css: "CSS",
                "web-design": "تصميم الويب",
                "responsive-design": "تصميم متجاوب",
                "grid-layout": "تخطيط الشبكة",
                reglementations: "لوائح",
                tech: "تقنية",
                "vie-privee": "الخصوصية",
                donnees: "البيانات"
            }
        },
        blogPost: {
            backToBlog: "العودة إلى المدوّنة",
            readMore: "عرض مقالات أخرى",
            availableLanguagesTitle: "متوفر بلغات أخرى",
            originalBadge: "النص الأصلي",
            tableOfContentsTitle: "جدول المحتويات",
            keywords: "الكلمات المفتاحية",
            date: "التاريخ",
            readingTime: "دقائق قراءة",
            views: "مشاهدات",
            share: {
                title: "شارك هذا المقال",
                twitter: "تويتر",
                linkedin: "لينكدإن",
                facebook: "فيسبوك",
                reddit: "Reddit",
                whatsapp: "واتساب",
                telegram: "تيليجرام",
                email: "البريد الإلكتروني",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "مشاركة عبر جهازك",
                copy: "نسخ الرابط",
                errorNoUrlTitle: "التشارك غير متاح",
                errorNoUrlDescription: "تعذّر الحصول على رابط المقال.",
                errorWindowTitle: "تعذّر فتح نافذة المشاركة",
                errorWindowDescription: "لم نتمكن من فتح نافذة المشاركة.",
                copySuccessTitle: "تم نسخ الرابط",
                copySuccessDescription: "تم نسخ رابط المقال إلى الحافظة.",
                copyErrorTitle: "فشل النسخ",
                copyErrorDescription: "يرجى المحاولة مرة أخرى أو نسخ العنوان يدويًا."
            },
            newsletter: {
                badge: "ابق في الصدارة",
                title: "ألهم مشاريعك 2025-2026",
                description: "احصل أسبوعيًا على موجز عن اتجاهات التقنية الفرنسية وأدوات الذكاء الاصطناعي والأساليب العملية لتسريع منتجاتك.",
                namePlaceholder: "اسمك (اختياري)",
                emailPlaceholder: "بريدك@example.com",
                buttonIdle: "اشترك الآن",
                buttonLoading: "جارٍ الاشتراك...",
                infoDefault: "لا رسائل مزعجة؛ فقط أفكار مفيدة وأدوات جاهزة لمبادراتك 2025-2026. يمكنك إلغاء الاشتراك في أي وقت.",
                infoSuccess: "شكرًا لك! يرجى التحقق من بريدك لتأكيد الاشتراك.",
                toastMissingEmailTitle: "البريد الإلكتروني مطلوب",
                toastMissingEmailDescription: "يرجى إدخال بريد إلكتروني صالح لتصلك تحديثاتنا.",
                toastSuccessTitle: "مرحبًا بك في النشرة!",
                toastSuccessDescription: "ستصلك مقالاتنا وتحليلاتنا قريبًا.",
                toastErrorTitle: "فشل الاشتراك",
                toastErrorDescription: "يرجى المحاولة مرة أخرى بعد لحظات."
            }
        },
        articleReader: {
            title: "استمع إلى المقال",
            loading: "جارٍ التحميل...",
            voiceLabel: "الصوت",
            femaleVoice: "أنثى",
            maleVoice: "ذكر",
            volumeLabel: "مستوى الصوت",
            poweredBy: "Nukoe للتحويل الصوتي"
        }
    },
    zh: {
        cvLinkText: "查看我的简历",
        visitText: "访问",
        heroTitle: "米卡埃尔·赛义德，全栈开发者（前端和后端）",
        heroSubtitle: "我开发各种类型的网络应用",
        presentationTitle: "你好，我叫米卡埃尔，欢迎来到我的作品集！",
        presentationText: "我拥有软件工程硕士学位，目前正在寻找一家公司来应用我的开发技能。对计算机的热情已经有十多年了，网页开发一直让我着迷。",
        skillsTitle: "技能",
        toolsTitle: "我在大多数项目中使用的工具",
        projectsTitle: "我曾工作的公司",
        documentationTitle: "文档（PDF）",
        seemoreText: "想知道更多吗？",
        frontendTitle: "前端",
        masteredTechTitle: "掌握的语言/技术",
        projetsText: "我曾工作的公司",
        docDescription1: "此文档可作为设计安全和加密系统的基础。",
        docDescription2: "针对网站的最常见网络攻击的大部分内容。",
        docDescription3: "生物识别手段在IT系统和网站的安全性中被越来越多地使用。",
        company1: "PHP (Symfony) 应用程序的高级开发和优化，集成AWS和DynamoDB等可扩展性技术。改进和重构Symfony和Angular中的现有模块，以优化性能和代码可维护性。设计和集成高级定制系统，实现动态网站颜色修改。架构现代化以增强应用平台的稳定性和可扩展性。",
        company2: "设计和开发专用于动态表单管理的网络平台，受TypeForm启发，利用Symfony 4、PHP和JavaScript。使用PHPUnit实施高级功能测试，以确保平台及其应用架构的稳定性、可靠性和整体质量。",
        company3: "使用Symfony/Laravel开发定制网络解决方案，包括REST API集成和前端实现。使用Docker和GitLab CI/CD自动化部署，减少人为错误并加速生产发布。数据库优化（MySQL、PostgreSQL），实现SQL查询执行时间减少50%。为各种客户提供可扩展性和传统架构重新设计的技术咨询和支持。",
        company4: "使用PHP、SQL、HTML、CSS、JavaScript和jQuery开发定制解决方案。积极参与专有框架的持续改进和演进，确保其稳定性、可扩展性以及与新兴市场技术的兼容性。",
        company5: "使用AngularJS开发和集成交互式动态用户界面，利用HTML、CSS和Bootstrap确保流畅和响应式的用户体验。实施前端最佳实践，以保证性能、可维护性和跨平台兼容性。",
        company6: "2012年创建的VPS（虚拟私人服务器）服务提供商，通过分配具有10gbps DDoS保护的专用服务器。",
        backendTitle: "后端",
        masteredBackendTechTitle: "掌握的语言/技术",
        machineLearningTitle: "机器学习",
        frameworksTitle: "框架/库",
        // Additional Chinese translations
        toolsSubtitle: "我用来实现创意的专业工具和技术",
        projectsSubtitle: "通过创新公司和挑战性项目的职业历程",
        documentationSubtitle: "关于网络安全和系统架构的技术文档和研究论文",
        contactSubtitle: "准备好实现您的下一个项目？让我们合作创造一些令人惊叹的东西。",
        contactGetInTouch: "联系我",
        contactFollowMe: "关注我",
        contactSendMessage: "发送消息",
        contactAvailable: "可接受项目",
        contactAvailableDesc: "目前接受新的自由职业项目和全职机会。响应时间：24-48小时。",
        contactNameLabel: "姓名",
        contactEmailLabel: "邮箱",
        contactSubjectLabel: "主题",
        contactMessageLabel: "消息",
        contactNamePlaceholder: "您的全名",
        contactEmailPlaceholder: "your.email@example.com",
        contactSubjectPlaceholder: "项目咨询、合作等",
        contactMessagePlaceholder: "告诉我您的项目、要求、时间安排和预算...",
        contactSendButton: "发送消息",
        contactSendingButton: "发送中...",
        contactErrorTitle: "发送时出错",
        contactErrorMessage: "发送消息时发生错误。请稍后再试。",
        contactTimeoutMessage: "请求超时。请检查您的网络连接并重试。",
        footerMadeWith: "制作于",
        footerPoweredBy: "技术支持",
        footerRights: "版权所有。",
        footerBuiltWith: "使用 React • TypeScript • Tailwind CSS • Vite 构建",
        statsYearsExp: "年工作经验",
        statsProjectsDone: "完成项目",
        statsUsersReached: "触达用户",
        statsProjectsCompleted: "已完成项目",
        statsUsersImpacted: "影响用户",
        statsTechMastered: "掌握技术",
        developmentCategory: "开发",
        databasesCategory: "数据库",
        cloudDevOpsCategory: "云端与开发运维",
        designCategory: "设计",
        testingCategory: "测试与质量保证",
        buildToolsCategory: "构建工具",
        coreStackTitle: "核心技术栈",
        docLibraryTitle: "技术文档库",
        docLibraryDesc: "这些综合文档代表了在网络安全、系统架构和现代身份验证系统方面多年的研究和实践经验。每篇论文都提供了详细的见解、实施指南和企业级解决方案的最佳实践。",
        docTotalPages: "总页数",
        docResearchPapers: "研究论文",
        docEnterpriseReady: "企业就绪",
        downloadPdf: "下载PDF",
        preview: "预览",
        pages: "页",
        missingInfo: "信息缺失",
        fillRequired: "请填写所有必填字段。",
        messageSent: "消息已发送！",
        messageThankYou: "感谢您的消息。我会尽快回复您。",
        menu: {
            skills: "技能",
            tools: "工具",
            projects: "项目",
            blog: "博客",
            games: "游戏",
            chat: "聊天",
            docs: "文档",
            contact: "联系"
        },
        themeToggle: {
            light: "切换到浅色模式",
            dark: "切换到深色模式"
        },
        blog: {
            title: "博客",
            subtitle: "探索前沿见解和实用指南",
            searchPlaceholder: "搜索文章...",
            searchButton: "搜索",
            filterAll: "全部",
            loading: "正在加载文章...",
            noResults: "未找到文章",
            clearFilters: "清除筛选",
            tags: {
                "developpement-web": "网页开发",
                "intelligence-artificielle": "人工智能",
                "machine-learning": "机器学习",
                ia: "人工智能",
                developpement: "开发",
                "revue-de-code": "代码审查",
                productivite: "生产力",
                outils: "工具",
                startups: "初创公司",
                technologie: "技术",
                innovation: "创新",
                durabilite: "可持续性",
                fintech: "金融科技",
                react: "React",
                pwa: "渐进式网页应用",
                microservices: "微服务",
                "technologie-moderne": "现代技术",
                css: "CSS",
                "web-design": "网页设计",
                "responsive-design": "响应式设计",
                "grid-layout": "网格布局",
                reglementations: "监管规定",
                tech: "科技",
                "vie-privee": "隐私",
                donnees: "数据"
            }
        },
        blogPost: {
            backToBlog: "返回博客",
            readMore: "查看更多文章",
            availableLanguagesTitle: "提供其他语言版本",
            originalBadge: "原文",
            tableOfContentsTitle: "目录",
            keywords: "关键词",
            date: "日期",
            readingTime: "分钟阅读",
            views: "浏览量",
            share: {
                title: "分享本文",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                facebook: "Facebook",
                reddit: "Reddit",
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                email: "邮箱",
                hackernews: "Hacker News",
                pocket: "Pocket",
                native: "通过您的设备分享",
                copy: "复制链接",
                errorNoUrlTitle: "无法分享",
                errorNoUrlDescription: "无法获取文章链接。",
                errorWindowTitle: "分享失败",
                errorWindowDescription: "无法打开分享窗口。",
                copySuccessTitle: "链接已复制",
                copySuccessDescription: "文章链接已复制到剪贴板。",
                copyErrorTitle: "复制失败",
                copyErrorDescription: "请重试或手动复制地址。"
            },
            newsletter: {
                badge: "保持领先",
                title: "为 2025-2026 项目汲取灵感",
                description: "每周获取法国科技趋势、AI 工具和加速产品的实用方法精选。",
                namePlaceholder: "您的名字（可选）",
                emailPlaceholder: "your.email@example.com",
                buttonIdle: "订阅",
                buttonLoading: "正在订阅...",
                infoDefault: "无垃圾邮件，只提供 2025-2026 计划所需的洞察和实用工具。可随时退订。",
                infoSuccess: "谢谢！请查收邮件确认订阅。",
                toastMissingEmailTitle: "需要邮箱地址",
                toastMissingEmailDescription: "请提供有效的邮箱以便接收更新。",
                toastSuccessTitle: "欢迎订阅新闻简报！",
                toastSuccessDescription: "稍后您将收到最新文章和洞察。",
                toastErrorTitle: "订阅失败",
                toastErrorDescription: "请稍后再试。"
            }
        },
        articleReader: {
            title: "收听文章",
            loading: "加载中...",
            voiceLabel: "语音",
            femaleVoice: "女声",
            maleVoice: "男声",
            volumeLabel: "音量",
            poweredBy: "Nukoe 语音转录"
        }
    },
    ja: {
        cvLinkText: "履歴書を見る",
        visitText: "訪問",
        heroTitle: "ミカエル・サイディ、フルスタック開発者（フロントエンドとバックエンド）",
        heroSubtitle: "あらゆる種類のウェブアプリケーションを開発しています",
        presentationTitle: "こんにちは、私の名前はミカエルです。私のポートフォリオへようこそ！",
        presentationText: "ソフトウェア工学の修士号を取得しており、現在、私の開発スキルを活かせる会社を探しています。10年以上にわたりコンピュータに情熱を持ち続けており、ウェブ開発は常に私を魅了してきました。",
        skillsTitle: "スキル",
        toolsTitle: "私がほとんどのプロジェクトで使用するツール",
        projectsTitle: "私が働いた会社",
        documentationTitle: "文書（PDF）",
        seemoreText: "もっと知りたいですか？",
        frontendTitle: "フロントエンド",
        masteredTechTitle: "習得した言語/技術",
        projetsText: "私が働いた会社",
        docDescription1: "この文書は、安全で暗号化されたシステムの設計の基礎として使用できます。",
        docDescription2: "ウェブサイトに対する最も一般的なサイバー攻撃の多く。",
        docDescription3: "生体認証手段は、ITシステムやウェブサイトのセキュリティのためにますます使用されています。",
        company1: "PHP（Symfony）アプリケーションの高度な開発と最適化、AWSやDynamoDBなどのスケーラビリティ技術を統合。SymfonyとAngularの既存モジュールの改善とリファクタリングによるパフォーマンスとコードの保守性の最適化。動的なサイトカラー変更を可能にする高度なカスタマイズシステムの設計と統合。アプリケーションプラットフォームの安定性とスケーラビリティを強化するためのアーキテクチャの近代化。",
        company2: "TypeFormに触発された動的フォーム管理専用のWebプラットフォームの設計と開発、Symfony 4、PHP、JavaScriptを活用。PHPUnitによる高度な機能テストの実装により、プラットフォームとそのアプリケーションアーキテクチャの安定性、信頼性、全体的な品質を確保。",
        company3: "Symfony/Laravelを使用したカスタムWebソリューションの開発、REST API統合とフロントエンド実装を含む。DockerとGitLab CI/CDによる展開の自動化により、人為的ミスを削減し本番リリースを加速。データベース最適化（MySQL、PostgreSQL）により、SQLクエリ実行時間を50%削減。さまざまなクライアント向けのスケーラビリティとレガシーアーキテクチャの再設計に関する技術コンサルティングとサポート。",
        company4: "PHP、SQL、HTML、CSS、JavaScript、jQueryでのカスタムソリューションの開発。独自フレームワークの継続的な改善と進化への積極的な貢献により、その安定性、スケーラビリティ、新興市場技術との互換性を確保。",
        company5: "AngularJSでのインタラクティブで動的なユーザーインターフェースの開発と統合、HTML、CSS、Bootstrapを活用してスムーズでレスポンシブなユーザーエクスペリエンスを確保。フロントエンドのベストプラクティスの実装により、パフォーマンス、保守性、クロスプラットフォーム互換性を保証。",
        company6: "2012年にDDoS保護付きの専用サーバーを配布するVPS（仮想プライベートサーバー）サービスプロバイダーを設立しました。",
        backendTitle: "バックエンド",
        masteredBackendTechTitle: "習得した言語/技術",
        machineLearningTitle: "機械学習",
        frameworksTitle: "フレームワーク/ライブラリ",
        // Additional Japanese translations
        toolsSubtitle: "アイデアを実現するために使用するプロフェッショナルツールと技術",
        projectsSubtitle: "革新的な企業と挑戦的なプロジェクトを通じたプロフェッショナルな旅",
        documentationSubtitle: "サイバーセキュリティとシステムアーキテクチャに関する技術文書と研究論文",
        contactSubtitle: "次のプロジェクトを実現する準備はできていますか？一緒に協力して素晴らしいものを作りましょう。",
        contactGetInTouch: "お問い合わせ",
        contactFollowMe: "フォローする",
        contactSendMessage: "メッセージを送信",
        contactAvailable: "プロジェクト受付中",
        contactAvailableDesc: "現在、新しいフリーランスプロジェクトとフルタイムの機会を受け付けています。返信時間：24-48時間。",
        contactNameLabel: "お名前",
        contactEmailLabel: "メールアドレス",
        contactSubjectLabel: "件名",
        contactMessageLabel: "メッセージ",
        contactNamePlaceholder: "お名前",
        contactEmailPlaceholder: "your.email@example.com",
        contactSubjectPlaceholder: "プロジェクトのお問い合わせ、コラボレーションなど",
        contactMessagePlaceholder: "プロジェクト、要件、スケジュール、予算についてお聞かせください...",
        contactSendButton: "メッセージを送信",
        contactSendingButton: "送信中...",
        contactErrorTitle: "送信中にエラーが発生しました",
        contactErrorMessage: "メッセージ送信中にエラーが発生しました。しばらくしてから再試行してください。",
        contactTimeoutMessage: "リクエストがタイムアウトしました。接続を確認して再試行してください。",
        footerMadeWith: "制作：",
        footerPoweredBy: "技術提供：",
        footerRights: "すべての権利を保有。",
        footerBuiltWith: "React • TypeScript • Tailwind CSS • Vite で構築",
        statsYearsExp: "年の経験",
        statsProjectsDone: "完了プロジェクト",
        statsUsersReached: "リーチしたユーザー",
        statsProjectsCompleted: "完了したプロジェクト",
        statsUsersImpacted: "影響を与えたユーザー",
        statsTechMastered: "習得した技術",
        developmentCategory: "開発",
        databasesCategory: "データベース",
        cloudDevOpsCategory: "クラウド&DevOps",
        designCategory: "デザイン",
        testingCategory: "テスト&QA",
        buildToolsCategory: "ビルドツール",
        coreStackTitle: "コア技術スタック",
        docLibraryTitle: "技術文書ライブラリ",
        docLibraryDesc: "これらの包括的な文書は、サイバーセキュリティ、システムアーキテクチャ、現代の認証システムにおける長年の研究と実践経験を表しています。各論文は、エンタープライズレベルのソリューションのための詳細な洞察、実装ガイドライン、ベストプラクティスを提供します。",
        docTotalPages: "総ページ数",
        docResearchPapers: "研究論文",
        docEnterpriseReady: "エンタープライズ対応",
        downloadPdf: "PDFダウンロード",
        preview: "プレビュー",
        pages: "ページ",
        missingInfo: "情報が不足しています",
        fillRequired: "必須フィールドをすべて入力してください。",
        messageSent: "メッセージが送信されました！",
        messageThankYou: "メッセージをありがとうございます。すぐに返信いたします。",
        menu: {
            skills: "スキル",
            tools: "ツール",
            projects: "プロジェクト",
            blog: "ブログ",
            games: "ゲーム",
            chat: "チャット",
            docs: "文書",
            contact: "連絡"
        },
        themeToggle: {
            light: "ライトモードに切り替え",
            dark: "ダークモードに切り替え"
        },
        blog: {
            title: "ブログ",
            subtitle: "最先端の洞察と実践的なガイドを発見",
            searchPlaceholder: "記事を検索...",
            searchButton: "検索",
            filterAll: "すべて",
            loading: "記事を読み込み中...",
            noResults: "記事が見つかりません",
            clearFilters: "フィルターをクリア",
            tags: {
                "developpement-web": "ウェブ開発",
                "intelligence-artificielle": "人工知能",
                "machine-learning": "機械学習",
                ia: "AI",
                developpement: "開発",
                "revue-de-code": "コードレビュー",
                productivite: "生産性",
                outils: "ツール",
                startups: "スタートアップ",
                technologie: "テクノロジー",
                innovation: "イノベーション",
                durabilite: "持続可能性",
                fintech: "フィンテック",
                react: "React",
                pwa: "プログレッシブウェブアプリ",
                microservices: "マイクロサービス",
                "technologie-moderne": "最新技術",
                css: "CSS",
                "web-design": "ウェブデザイン",
                "responsive-design": "レスポンシブデザイン",
                "grid-layout": "グリッドレイアウト",
                reglementations: "規制",
                tech: "テック",
                "vie-privee": "プライバシー",
                donnees: "データ"
            }
        },
        blogPost: {
            backToBlog: "ブログに戻る",
            readMore: "ほかの記事を見る",
            availableLanguagesTitle: "他の言語でも読む",
            originalBadge: "オリジナル",
            tableOfContentsTitle: "目次",
            keywords: "キーワード",
            date: "日付",
            readingTime: "分の読み取り",
            views: "閲覧数",
            share: {
                title: "この記事をシェア",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                copy: "リンクをコピー",
                errorNoUrlTitle: "共有できません",
                errorNoUrlDescription: "記事のURLを取得できませんでした。",
                errorWindowTitle: "共有に失敗しました",
                errorWindowDescription: "共有ウィンドウを開けませんでした。",
                copySuccessTitle: "リンクをコピーしました",
                copySuccessDescription: "記事のリンクをクリップボードにコピーしました。",
                copyErrorTitle: "コピーに失敗しました",
                copyErrorDescription: "もう一度お試しになるか、URLを手動でコピーしてください。"
            },
            newsletter: {
                badge: "最新情報を逃さない",
                title: "2025-2026年のプロジェクトにインスピレーションを",
                description: "毎週、フランスのテックトレンドとAIツール、プロダクトを加速させる実践的なヒントをお届けします。",
                namePlaceholder: "お名前（任意）",
                emailPlaceholder: "your.email@example.com",
                buttonIdle: "購読する",
                buttonLoading: "購読手続き中...",
                infoDefault: "スパムはありません。2025-2026年の取り組みに役立つ洞察と実践的なツールだけをお届けします。いつでも解除できます。",
                infoSuccess: "ありがとうございます！メールをご確認のうえ購読を確定してください。",
                toastMissingEmailTitle: "メールアドレスが必要です",
                toastMissingEmailDescription: "最新情報を受け取るには有効なメールアドレスを入力してください。",
                toastSuccessTitle: "ニュースレターへようこそ！",
                toastSuccessDescription: "まもなく最新の記事とインサイトをお届けします。",
                toastErrorTitle: "購読に失敗しました",
                toastErrorDescription: "しばらくしてからもう一度お試しください。"
            }
        },
        articleReader: {
            title: "記事を聞く",
            loading: "読み込み中...",
            voiceLabel: "音声",
            femaleVoice: "女性",
            maleVoice: "男性",
            volumeLabel: "音量",
            poweredBy: "Nukoe 音声トランスクリプション"
        }
    },
    ru: {
        cvLinkText: "Посмотреть мое резюме",
        visitText: "Посетить",
        heroTitle: "Микаэль Саиди, Полностековый разработчик (Frontend и Backend)",
        heroSubtitle: "Я разрабатываю все типы веб-приложений",
        presentationTitle: "Здравствуйте, меня зовут Микаэль, добро пожаловать в мое портфолио!",
        presentationText: "Я окончил магистратуру по программной инженерии и сейчас ищу компанию, в которой смогу применить свои навыки разработки. Я увлекаюсь компьютерами более десяти лет, веб-разработка всегда меня fascinates.",
        skillsTitle: "Навыки",
        toolsTitle: "Инструменты, которые я использую для большинства своих проектов",
        projectsTitle: "Компании, с которыми я работал",
        documentationTitle: "Документации (PDF)",
        seemoreText: "Хотите узнать больше?",
        frontendTitle: "Frontend",
        masteredTechTitle: "Языки / технологии, которые я освоил",
        projetsText: "Компании, с которыми я работал",
        docDescription1: "Эта документация может служить основой для проектирования безопасной и зашифрованной системы.",
        docDescription2: "Большая часть наиболее распространенных кибератак на веб-сайты.",
        docDescription3: "Биометрические средства все чаще используются для безопасности ИТ-систем и веб-сайтов.",
        company1: "Расширенная разработка и оптимизация PHP-приложений (Symfony) с интеграцией технологий масштабируемости, таких как AWS и DynamoDB. Улучшение и рефакторинг существующих модулей в Symfony и Angular для оптимизации производительности и поддерживаемости кода. Разработка и интеграция расширенной системы кастомизации, позволяющей динамически изменять цвета сайта. Модернизация архитектуры для укрепления стабильности и масштабируемости платформ приложений.",
        company2: "Проектирование и разработка веб-платформы для управления динамическими формами, вдохновленной TypeForm, с использованием Symfony 4, PHP и JavaScript. Реализация расширенного функционального тестирования с помощью PHPUnit для обеспечения стабильности, надежности и общего качества платформы и ее архитектуры приложений.",
        company3: "Разработка индивидуальных веб-решений с использованием Symfony/Laravel, включая интеграцию REST API и front-end реализацию. Автоматизация развертывания с помощью Docker и GitLab CI/CD, сокращение человеческих ошибок и ускорение производственных релизов. Оптимизация баз данных (MySQL, PostgreSQL) с достижением 50% сокращения времени выполнения SQL-запросов. Техническое консультирование и поддержка по масштабируемости и редизайну устаревших архитектур для различных клиентов.",
        company4: "Разработка индивидуальных решений на PHP, SQL, HTML, CSS, JavaScript и jQuery. Активное участие в постоянном улучшении и развитии собственного фреймворка, обеспечивая его стабильность, масштабируемость и совместимость с новыми рыночными технологиями.",
        company5: "Разработка и интеграция интерактивных и динамических пользовательских интерфейсов на AngularJS с использованием HTML, CSS и Bootstrap для обеспечения плавного и адаптивного пользовательского опыта. Внедрение лучших практик front-end для обеспечения производительности, поддерживаемости и кроссплатформенной совместимости.",
        company6: "Создание в 2012 году провайдера VPS (виртуального частного сервера) с распределением выделенного сервера с защитой от DDoS на 10 Гбит/с.",
        backendTitle: "Backend",
        masteredBackendTechTitle: "Языки / технологии, которые я освоил",
        machineLearningTitle: "Машинное обучение",
        frameworksTitle: "Фреймворки / библиотеки",
        // Additional Russian translations
        toolsSubtitle: "Профессиональные инструменты и технологии, которые я использую для воплощения идей в жизнь",
        projectsSubtitle: "Профессиональный путь через инновационные компании и сложные проекты",
        documentationSubtitle: "Техническая документация и исследовательские работы по кибербезопасности и архитектуре систем",
        contactSubtitle: "Готовы воплотить ваш следующий проект в жизнь? Давайте сотрудничать и создадим что-то удивительное вместе.",
        contactGetInTouch: "Связаться со мной",
        contactFollowMe: "Подписаться",
        contactSendMessage: "Отправить сообщение",
        contactAvailable: "Доступен для проектов",
        contactAvailableDesc: "В настоящее время принимаю новые проекты и предложения о полной занятости. Время ответа: 24-48 часов.",
        contactNameLabel: "Имя",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Тема",
        contactMessageLabel: "Сообщение",
        contactNamePlaceholder: "Ваше полное имя",
        contactEmailPlaceholder: "your.email@example.com",
        contactSubjectPlaceholder: "Запрос проекта, сотрудничество и т.д.",
        contactMessagePlaceholder: "Расскажите мне о вашем проекте, требованиях, сроках и бюджете...",
        contactSendButton: "Отправить сообщение",
        contactSendingButton: "Отправка...",
        contactErrorTitle: "Ошибка при отправке",
        contactErrorMessage: "Произошла ошибка при отправке сообщения. Пожалуйста, попробуйте еще раз позже.",
        contactTimeoutMessage: "Время ожидания истекло. Проверьте подключение к сети и попробуйте снова.",
        footerMadeWith: "Создано с",
        footerPoweredBy: "при поддержке",
        footerRights: "Все права защищены.",
        footerBuiltWith: "Создано с помощью React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Лет опыта",
        statsProjectsDone: "Выполненных проектов",
        statsUsersReached: "Охваченных пользователей",
        statsProjectsCompleted: "Завершенных проектов",
        statsUsersImpacted: "Затронутых пользователей",
        statsTechMastered: "Освоенных технологий",
        developmentCategory: "Разработка",
        databasesCategory: "Базы данных",
        cloudDevOpsCategory: "Облако и DevOps",
        designCategory: "Дизайн",
        testingCategory: "Тестирование и QA",
        buildToolsCategory: "Инструменты сборки",
        coreStackTitle: "Основной технологический стек",
        docLibraryTitle: "Библиотека технической документации",
        docLibraryDesc: "Эти всеобъемлющие документы представляют годы исследований и практического опыта в области кибербезопасности, архитектуры систем и современных систем аутентификации. Каждая статья предоставляет подробные сведения, руководства по реализации и лучшие практики для решений корпоративного уровня.",
        docTotalPages: "Всего страниц",
        docResearchPapers: "Исследовательские работы",
        docEnterpriseReady: "Готово для предприятий",
        downloadPdf: "Скачать PDF",
        preview: "Предпросмотр",
        pages: "страниц",
        missingInfo: "Недостающая информация",
        fillRequired: "Пожалуйста, заполните все обязательные поля.",
        messageSent: "Сообщение отправлено!",
        messageThankYou: "Спасибо за ваше сообщение. Я скоро отвечу вам.",
        menu: {
            skills: "Навыки",
            tools: "Инструменты",
            projects: "Проекты",
            blog: "Блог",
            games: "Игры",
            chat: "Чат",
            docs: "Документы",
            contact: "Контакт"
        },
        themeToggle: {
            light: "Переключить на светлый режим",
            dark: "Переключить на темный режим"
        },
        blog: {
            title: "Блог",
            subtitle: "Откройте для себя передовые идеи и практические руководства",
            searchPlaceholder: "Искать статьи...",
            searchButton: "Поиск",
            filterAll: "Все",
            loading: "Загрузка статей...",
            noResults: "Статьи не найдены",
            clearFilters: "Сбросить фильтры",
            tags: {
                "developpement-web": "Веб-разработка",
                "intelligence-artificielle": "Искусственный интеллект",
                "machine-learning": "Машинное обучение",
                ia: "ИИ",
                developpement: "Разработка",
                "revue-de-code": "Код-ревью",
                productivite: "Продуктивность",
                outils: "Инструменты",
                startups: "Стартапы",
                technologie: "Технологии",
                innovation: "Инновации",
                durabilite: "Устойчивость",
                fintech: "Финтех",
                react: "React",
                pwa: "Прогрессивные веб-приложения",
                microservices: "Микросервисы",
                "technologie-moderne": "Современные технологии",
                css: "CSS",
                "web-design": "Веб-дизайн",
                "responsive-design": "Адаптивный дизайн",
                "grid-layout": "Сеточный макет",
                reglementations: "Регулирование",
                tech: "Тех",
                "vie-privee": "Конфиденциальность",
                donnees: "Данные"
            }
        },
        blogPost: {
            backToBlog: "Назад в блог",
            readMore: "Читать другие статьи",
            availableLanguagesTitle: "Доступно на других языках",
            originalBadge: "Оригинал",
            tableOfContentsTitle: "Оглавление",
            keywords: "Ключевые слова",
            date: "Дата",
            readingTime: "мин чтения",
            views: "просмотров",
            share: {
                title: "Поделиться статьёй",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                copy: "Скопировать ссылку",
                errorNoUrlTitle: "Невозможно поделиться",
                errorNoUrlDescription: "Не удалось получить ссылку на статью.",
                errorWindowTitle: "Не удалось открыть окно",
                errorWindowDescription: "Не удалось открыть окно для публикации.",
                copySuccessTitle: "Ссылка скопирована",
                copySuccessDescription: "Ссылка на статью скопирована в буфер обмена.",
                copyErrorTitle: "Ошибка копирования",
                copyErrorDescription: "Попробуйте ещё раз или скопируйте адрес вручную."
            },
            newsletter: {
                badge: "Будьте на шаг впереди",
                title: "Вдохновляйтесь для проектов 2025–2026",
                description: "Получайте раз в неделю подборку французских тех‑трендов, AI-инструментов и практических подходов для ускорения ваших продуктов.",
                namePlaceholder: "Ваше имя (необязательно)",
                emailPlaceholder: "your.email@example.com",
                buttonIdle: "Подписаться",
                buttonLoading: "Подписываем...",
                infoDefault: "Никакого спама — только полезные инсайты и готовые инструменты для инициатив 2025–2026. Отписаться можно в любой момент.",
                infoSuccess: "Спасибо! Проверьте почту, чтобы подтвердить подписку.",
                toastMissingEmailTitle: "Нужен email",
                toastMissingEmailDescription: "Укажите действительный email, чтобы получать обновления.",
                toastSuccessTitle: "Добро пожаловать в рассылку!",
                toastSuccessDescription: "Совсем скоро вы получите свежие статьи и аналитические материалы.",
                toastErrorTitle: "Не удалось оформить подписку",
                toastErrorDescription: "Попробуйте ещё раз через несколько секунд."
            }
        },
        articleReader: {
            title: "Прослушать статью",
            loading: "Загрузка...",
            voiceLabel: "Голос",
            femaleVoice: "Женский",
            maleVoice: "Мужской",
            volumeLabel: "Громкость",
            poweredBy: "Голосовая транскрипция Nukoe"
        }
    },
    pt: {
        cvLinkText: "Ver meu CV",
        visitText: "Visitar",
        heroTitle: "Mickael Saidi, Desenvolvedor Full-stack (Front-end e Back-end)",
        heroSubtitle: "Eu desenvolvo todos os tipos de aplicações web",
        presentationTitle: "Olá, meu nome é Mickael, bem-vindo ao meu portfólio!",
        presentationText: "Graduado com um mestrado em engenharia de software, atualmente estou procurando uma empresa para aplicar minhas habilidades de desenvolvimento. Sou apaixonado por computadores há mais de uma década e o desenvolvimento web sempre me fascinou.",
        skillsTitle: "Habilidades",
        toolsTitle: "As ferramentas que uso para a maioria dos meus projetos",
        projectsTitle: "As empresas para as quais trabalhei",
        documentationTitle: "Documentações (PDF)",
        seemoreText: "Quer saber mais?",
        frontendTitle: "Front-end",
        masteredTechTitle: "Linguagens / Tecnologias dominadas",
        projetsText: "As empresas para as quais trabalhei",
        docDescription1: "Esta documentação pode servir como base para projetar um sistema seguro e criptografado.",
        docDescription2: "Uma grande parte dos ataques cibernéticos mais comuns em sites.",
        docDescription3: "Os meios biométricos estão sendo usados cada vez mais para a segurança dos sistemas de TI e sites.",
        company1: "Desenvolvimento avançado e otimização de aplicações PHP (Symfony), integrando tecnologias de escalabilidade como AWS e DynamoDB. Melhoria e refatoração de módulos existentes em Symfony e Angular para otimizar o desempenho e a manutenibilidade do código. Design e integração de um sistema de personalização avançado que permite modificação dinâmica das cores do site. Modernização da arquitetura para reforçar a estabilidade e escalabilidade das plataformas aplicativas.",
        company2: "Design e desenvolvimento de uma plataforma web dedicada à gestão de formulários dinâmicos, inspirada no TypeForm, utilizando Symfony 4, PHP e JavaScript. Implementação de testes funcionais avançados com PHPUnit para garantir estabilidade, confiabilidade e qualidade geral da plataforma e sua arquitetura aplicativa.",
        company3: "Desenvolvimento de soluções web personalizadas usando Symfony/Laravel, incluindo integração de API REST e implementação front-end. Automação de implantação com Docker e GitLab CI/CD, reduzindo erros humanos e acelerando lançamentos de produção. Otimização de banco de dados (MySQL, PostgreSQL), alcançando uma redução de 50% no tempo de execução de consultas SQL. Consultoria técnica e suporte em escalabilidade e redesign de arquiteturas legacy para diversos clientes.",
        company4: "Desenvolvimento de soluções personalizadas em PHP, SQL, HTML, CSS, JavaScript e jQuery. Contribuição ativa para a melhoria contínua e evolução de um framework proprietário, garantindo sua estabilidade, escalabilidade e compatibilidade com tecnologias emergentes do mercado.",
        company5: "Desenvolvimento e integração de interfaces de usuário interativas e dinâmicas em AngularJS, aproveitando HTML, CSS e Bootstrap para garantir uma experiência de usuário fluida e responsiva. Implementação das melhores práticas de front-end para garantir desempenho, manutenibilidade e compatibilidade multiplataforma.",
        company6: "Provedor de VPS (Servidor Privado Virtual) criado em 2012, com alocação de servidor dedicado com proteção DDoS de 10 Gbps.",
        backendTitle: "Back-end",
        masteredBackendTechTitle: "Linguagens / Tecnologias dominadas",
        machineLearningTitle: "Aprendizado de máquina",
        frameworksTitle: "Frameworks / Bibliotecas",
        // Additional Portuguese translations
        toolsSubtitle: "Ferramentas e tecnologias profissionais que uso para dar vida às ideias",
        projectsSubtitle: "Jornada profissional através de empresas inovadoras e projetos desafiadores",
        documentationSubtitle: "Documentação técnica e trabalhos de pesquisa sobre cibersegurança e arquitetura de sistemas",
        contactSubtitle: "Pronto para dar vida ao seu próximo projeto? Vamos colaborar e criar algo incrível juntos.",
        contactGetInTouch: "Entre em contato",
        contactFollowMe: "Siga-me",
        contactSendMessage: "Enviar mensagem",
        contactAvailable: "Disponível para projetos",
        contactAvailableDesc: "Atualmente aceito novos projetos freelance e oportunidades de tempo integral. Tempo de resposta: 24-48 horas.",
        contactNameLabel: "Nome",
        contactEmailLabel: "Email",
        contactSubjectLabel: "Assunto",
        contactMessageLabel: "Mensagem",
        contactNamePlaceholder: "Seu nome completo",
        contactEmailPlaceholder: "seu.email@exemplo.com",
        contactSubjectPlaceholder: "Consulta de projeto, colaboração, etc.",
        contactMessagePlaceholder: "Conte-me sobre seu projeto, requisitos, cronograma e orçamento...",
        contactSendButton: "Enviar mensagem",
        contactSendingButton: "Enviando...",
        contactErrorTitle: "Erro ao enviar",
        contactErrorMessage: "Ocorreu um erro ao enviar sua mensagem. Tente novamente mais tarde.",
        contactTimeoutMessage: "A solicitação expirou. Verifique a conexão e tente novamente.",
        footerMadeWith: "Feito com",
        footerPoweredBy: "powered by",
        footerRights: "Todos os direitos reservados.",
        footerBuiltWith: "Construído com React • TypeScript • Tailwind CSS • Vite",
        statsYearsExp: "Anos de experiência",
        statsProjectsDone: "Projetos realizados",
        statsUsersReached: "Usuários alcançados",
        statsProjectsCompleted: "Projetos concluídos",
        statsUsersImpacted: "Usuários impactados",
        statsTechMastered: "Tecnologias dominadas",
        developmentCategory: "Desenvolvimento",
        databasesCategory: "Bancos de dados",
        cloudDevOpsCategory: "Cloud & DevOps",
        designCategory: "Design",
        testingCategory: "Testes & QA",
        buildToolsCategory: "Ferramentas de build",
        coreStackTitle: "Stack tecnológico principal",
        docLibraryTitle: "Biblioteca de documentação técnica",
        docLibraryDesc: "Estes documentos abrangentes representam anos de pesquisa e experiência prática em cibersegurança, arquitetura de sistemas e sistemas de autenticação modernos. Cada artigo fornece insights detalhados, diretrizes de implementação e melhores práticas para soluções de nível empresarial.",
        docTotalPages: "Total de páginas",
        docResearchPapers: "Artigos de pesquisa",
        docEnterpriseReady: "Pronto para empresa",
        downloadPdf: "Baixar PDF",
        preview: "Visualizar",
        pages: "páginas",
        missingInfo: "Informação em falta",
        fillRequired: "Por favor, preencha todos os campos obrigatórios.",
        messageSent: "Mensagem enviada!",
        messageThankYou: "Obrigado pela sua mensagem. Responderei em breve.",
        menu: {
            skills: "Habilidades",
            tools: "Ferramentas",
            projects: "Projetos",
            blog: "Blog",
            games: "Jogos",
            chat: "Chat",
            docs: "Documentos",
            contact: "Contato"
        },
        themeToggle: {
            light: "Mudar para modo claro",
            dark: "Mudar para modo escuro"
        },
        blog: {
            title: "Blog",
            subtitle: "Descubra insights inovadores e guias práticos",
            searchPlaceholder: "Buscar artigos...",
            searchButton: "Buscar",
            filterAll: "Todos",
            loading: "Carregando artigos...",
            noResults: "Nenhum artigo encontrado",
            clearFilters: "Limpar filtros",
            tags: {
                "developpement-web": "Desenvolvimento web",
                "intelligence-artificielle": "Inteligência artificial",
                "machine-learning": "Aprendizado de máquina",
                ia: "IA",
                developpement: "Desenvolvimento",
                "revue-de-code": "Revisão de código",
                productivite: "Produtividade",
                outils: "Ferramentas",
                startups: "Startups",
                technologie: "Tecnologia",
                innovation: "Inovação",
                durabilite: "Sustentabilidade",
                fintech: "Fintech",
                react: "React",
                pwa: "Aplicativos web progressivos",
                microservices: "Microsserviços",
                "technologie-moderne": "Tecnologia moderna",
                css: "CSS",
                "web-design": "Web design",
                "responsive-design": "Design responsivo",
                "grid-layout": "Layout em grade",
                reglementations: "Regulamentações",
                tech: "Tech",
                "vie-privee": "Privacidade",
                donnees: "Dados"
            }
        },
        blogPost: {
            backToBlog: "Voltar ao blog",
            readMore: "Ver mais artigos",
            availableLanguagesTitle: "Disponível em outros idiomas",
            originalBadge: "Original",
            tableOfContentsTitle: "Índice",
            keywords: "Palavras-chave",
            date: "Data",
            readingTime: "min de leitura",
            views: "visualizações",
            share: {
                title: "Compartilhar este artigo",
                twitter: "Twitter",
                linkedin: "LinkedIn",
                copy: "Copiar link",
                errorNoUrlTitle: "Compartilhamento indisponível",
                errorNoUrlDescription: "Não foi possível obter a URL do artigo.",
                errorWindowTitle: "Falha ao compartilhar",
                errorWindowDescription: "Não foi possível abrir a janela de compartilhamento.",
                copySuccessTitle: "Link copiado",
                copySuccessDescription: "O link do artigo foi copiado para a área de transferência.",
                copyErrorTitle: "Erro ao copiar",
                copyErrorDescription: "Tente novamente ou copie o endereço manualmente."
            },
            newsletter: {
                badge: "Fique na frente",
                title: "Inspire seus projetos 2025-2026",
                description: "Receba toda semana um resumo das tendências tech francesas, ferramentas de IA e abordagens práticas para acelerar seus produtos.",
                namePlaceholder: "Seu nome (opcional)",
                emailPlaceholder: "seu.email@exemplo.com",
                buttonIdle: "Inscreva-se",
                buttonLoading: "Inscrevendo...",
                infoDefault: "Nada de spam — apenas insights relevantes e ferramentas prontas para as suas iniciativas 2025-2026. Você pode cancelar quando quiser.",
                infoSuccess: "Obrigado! Verifique seu e-mail para confirmar a inscrição.",
                toastMissingEmailTitle: "E-mail obrigatório",
                toastMissingEmailDescription: "Informe um e-mail válido para receber nossas novidades.",
                toastSuccessTitle: "Bem-vindo à newsletter!",
                toastSuccessDescription: "Você receberá em breve nossos artigos e análises.",
                toastErrorTitle: "Falha na inscrição",
                toastErrorDescription: "Tente novamente em instantes."
            }
        },
        articleReader: {
            title: "Ouvir o artigo",
            loading: "Carregando...",
            voiceLabel: "Voz",
            femaleVoice: "Feminina",
            maleVoice: "Masculina",
            volumeLabel: "Volume",
            speedLabel: "Speed",            poweredBy: "Transcrição Vocal Nukoe"
        }
    }
} as const;

export type LocaleKey = keyof typeof translations;
export type TranslationDictionary = typeof translations[LocaleKey];
